import React, { useState, useEffect } from "react";
import ButtonFilled from "../requests/shared/helpers/ButtonFilled";
import { getRightworkAPI } from "../requests/utilities/requests";
import { postRightworkAPI } from "../requests/utilities/requests";
import {
  API_get_pay_periods,
  API_get_pay_period_employees,
  API_get_timecards_for_store,
  API_get_timecards_for_company,
  API_export_timecards_gusto,
  API_export_timecards_paylocity,
  API_export_tips_paylocity,
  API_post_timecard,
  API_delete_timecard,
  API_post_timecards_status,
  API_post_timecard_clock_out,
  API_post_timecard_break_clock_in,
  API_post_timecard_break_clock_out,
  API_get_list_users,
  API_get_timecards_for_employee,
  API_post_pay_period_approval,
  API_review_timecard_change_request,
  API_get_roles,
  API_post_pay_period
} from "../../../constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TimeClockHeader from "./TimeClockHeader";
import TimeEntriesHeader from "./TimeEntriesHeader";
import {
  formatDate,
  formatDateReadableWithDayOfWeekNoYear,
  formatDateReadableWithDayOfWeek,
  formatDateReadable,
} from "../requests/utilities/helpers";
import AlarmIcon from "@mui/icons-material/Alarm";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Drawer from "@mui/material/Drawer";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import DrawerHeader from "../requests/shared/helpers/DrawerHeader";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import MenuItem from "@mui/material/MenuItem";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ButtonOutlined from "../requests/shared/helpers/ButtonOutlined";
import DrawerFooterContainerLarge from "../requests/shared/helpers/DrawerFooterContainerLarge";
import ButtonDelete from "../requests/shared/helpers/ButtonDelete";
import SendIcon from "@mui/icons-material/Send";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import DownloadIcon from "@mui/icons-material/Download";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AddIcon from "@mui/icons-material/Add";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LoadSpinner from "../../../utilities/LoadSpinner";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import TimePickerInput from "./TimePickerInputs";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BlinkingDot from "./BlinkingDot";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TimeEntriesSettings from "./TimeEntriesSettings";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import EarningsBarChart from "./EarningsBarChart";
import { hoursToMinutes } from "../../../helpers/helpers";
import TimeEntriesReviewCardManager from "./TimeEntriesReviewCardManager";
import CalculateIcon from '@mui/icons-material/Calculate';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { ThemeProvider } from '@mui/material/styles';
import TipCalculatorModal from "../tip_calculator/TipCalculatorModal";
import TimecardHistoryTooltip from "./TimecardHistoryTooltip";
import GavelIcon from "@mui/icons-material/Gavel";
import LaborComplianceAuditModal from "./LaborComplianceAuditModal";
import TimecardChangeRequestsPanel from "./TimecardChangeRequestsPanel";
import TimecardRangeReport from "./TimecardRangeReport";
import FlagReasonsTooltip from "./FlagReasonsTooltip";
import DateRangeIcon from "@mui/icons-material/DateRange";
import BreakDetails from "./BreakDetails";
import TimeEntryActions from "./TimeEntryActions";
import BreakEditor from "./BreakEditor";
import { breakBoundsError, validateBreaks } from "./timecardBreakUtils";
import timeClockTheme from "./timeClockTheme";

const TimeEntriesViewSwitcher = ({ value, onChange }) => {
  const options = [
    { value: "all", label: "By time entry" },
    { value: "by_employee", label: "By employee" },
  ];

  return (
    <div
      className="mt-3 inline-flex rounded-lg border border-slate-200 bg-slate-100 p-1"
      role="group"
      aria-label="Time entry view"
    >
      {options.map((option) => {
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600 focus-visible:ring-offset-2 ${
              isActive
                ? "bg-violet-700 text-white shadow-sm"
                : "text-slate-600 hover:bg-white hover:text-slate-900"
            }`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

function TimeEntriesDisplay(props) {
  const default_data = {
    clocked_in_at: null,
    clocked_out_at: null,
    clocked_in_at_date_time: new Date(),
    clocked_out_at_date_time: new Date(),
    declared_cash_tips: null,
    published_schedule: null,
    status: null,
    store_team_member: {
      first_name: "",
      last_name: "",
      id: null,
    },
    wage_type: null,
    timecard_breaks: [],
    uuid: null,
    role: null,
    manager_note: "",
    paid_break_minutes: 0,
  };


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSubmitted(false);
  };
  const [modalData, setModalData] = React.useState(default_data);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  const [showSettings, setShowSettings] = React.useState(false);

  const [tipCalculatorOpen, setTipCalculatorOpen] = useState(false);
  const [complianceAuditOpen, setComplianceAuditOpen] = useState(false);

  const [payPeriods, setPayPeriods] = React.useState([]);
  const [payPeriodEmployees, setPayPeriodEmployees] = React.useState([]);
  const [selectedPayPeriodUUID, setSelectedPayPeriodUUID] =
    React.useState(null);
  const [platformTipTotalCents, setPlatformTipTotalCents] = React.useState(null);
  const [creditCardTipAmountCents, setCreditCardTipAmountCents] = React.useState(null);
  const [cashTipAmountCents, setCashTipAmountCents] = React.useState(null);
  const [tipList, setTipList] = React.useState([]);

  const [showCustomRange, setShowCustomRange] = useState(false);
  const [timeEntries, setTimeEntries] = React.useState([]);
  const [paidBreakTrackingEnabled, setPaidBreakTrackingEnabled] = React.useState(false);
  const [selectedPayPeriodDates, setSelectedPayPeriodDates] = React.useState(
    []
  );

  const [timeEntriesDisplay, setTimeEntriesDisplay] = React.useState("all");

  const [selectedEmployee, setSelectedEmployee] = React.useState(null);
  const [selectedEmployeeTimeEntries, setSelectedEmployeeTimeEntries] =
    React.useState([]);
  const [selectedEmployeeSummaryList, setSelectedEmployeeSummaryList] =
    React.useState([]);
  const [selectedEmployeeChangeRequests, setSelectedEmployeeChangeRequests] =
    React.useState([]);
  const [storeChangeRequests, setStoreChangeRequests] = React.useState([]);
  const [storeChangeRequestsModalOpen, setStoreChangeRequestsModalOpen] =
    React.useState(false);

  const [employeeList, setEmployeeList] = useState([]);
  const [rolesList, setRolesList] = useState([]);

  const [showTimeEntries, setShowTimeEntries] = useState(false);

  const [isLoading, setIsLoading] = React.useState(false);
  const [isExporting, setIsExporting] = React.useState(false);
  const [isPublishing, setIsPublishing] = React.useState(false);
  const selectedPayPeriodIsMutable = ["in_progress", "pending"].includes(
    payPeriods.find((period) => period.uuid === selectedPayPeriodUUID)?.status
  );

  const invalidateOverviewCacheProp = props.invalidateOverviewCache;
  const invalidateOverviewCache = React.useCallback(() => {
    invalidateOverviewCacheProp?.();
  }, [invalidateOverviewCacheProp]);

  useEffect(() => {
    setShowTimeEntries(false);
    fetchPayPeriods(true);
    fetchEmployeeList();
    fetchRoles();
    setTimeEntries([]);
    setSelectedPayPeriodDates([]);
    // setTimeEntriesDisplay("by_employee");
    setTimeEntriesDisplay("all");
    setSelectedEmployee(null);
    setSelectedEmployeeTimeEntries([]);
    setSelectedEmployeeChangeRequests([]);
    setStoreChangeRequests([]);
    setStoreChangeRequestsModalOpen(false);
  }, [props.homeStore]);

  useEffect(() => {
    if (storeChangeRequests.length === 0) {
      setStoreChangeRequestsModalOpen(false);
    }
  }, [storeChangeRequests.length]);

  const fetchPayPeriods = async (showLoading) => {
    setIsLoading(showLoading);
    let api_params = { store_id: props.homeStore };
    let api = API_get_pay_periods;
    try {
      const res = await getRightworkAPI(api, api_params);
      // console.log(res);
      if (res.status === 200) {
        const data = res.data?.redux?.payload?.pay_periods;
        setPayPeriods(data);
        setIsLoading(false);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  const fetchPayPeriodEmployees = async (showLoading, pay_period_uuid) => {
    // setIsLoading(showLoading);
    let api_params = {
      store_id: props.homeStore,
      pay_period_uuid: pay_period_uuid,
    };
    let api = API_get_pay_period_employees;
    try {
      const res = await getRightworkAPI(api, api_params);
      console.log("RES", res);
      if (res.status === 200) {
        const employees = res.data?.redux?.payload?.employees;
        const platform_tip_total_cents = res.data?.redux?.payload?.platform_tip_total_cents;
        const manually_entered_credit_card_tip_amount_cents = res.data?.redux?.payload?.manually_entered_credit_card_tip_amount_cents;
        const manually_entered_cash_tip_amount_cents = res.data?.redux?.payload?.manually_entered_cash_tip_amount_cents;
        const pay_period_approvals_with_tips_list = res.data?.redux?.payload?.pay_period_approvals_with_tips_list || [];
        setPayPeriodEmployees(employees);
        setPlatformTipTotalCents(platform_tip_total_cents);
        setCreditCardTipAmountCents(manually_entered_credit_card_tip_amount_cents);
        setCashTipAmountCents(manually_entered_cash_tip_amount_cents);
        setTipList(pay_period_approvals_with_tips_list);

        // setIsLoading(false);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  console.log("PAY PERIOD EMPLOYEES", payPeriodEmployees)

  // Helper function to get tips display for an employee
  const getTipsDisplay = (employeeId) => {
    // If no tips have been calculated yet
    if (tipList.length === 0) {
      return "Not calculated";
    }

    // Find if this employee has a tip amount
    const tipApproval = tipList.find(
      tip => tip.store_team_member?.id === employeeId
    );

    if (tipApproval) {
      const cents = tipApproval.total_tip_amount_cents || 0;
      return `$${(cents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    // Employee was excluded from tips
    return "$0.00";
  };


  const fetchTimeCardsForEmployee = async (showLoading, date, stm_id) => {
    setIsLoading(showLoading);
    let api_params = {
      store_id: props.homeStore,
      date: date,
      stm_id,
    };
    let api = API_get_timecards_for_employee;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        setSelectedEmployeeTimeEntries(res.data.redux?.payload?.timecards);
        setSelectedEmployeeSummaryList(res.data?.redux?.payload?.summary_list);
        setPaidBreakTrackingEnabled(res.data?.redux?.payload?.paid_break_tracking_enabled ?? false);
        setSelectedEmployeeChangeRequests(
          res.data?.redux?.payload?.timecard_change_requests || []
        );
        setIsLoading(false);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  const reviewTimecardChangeRequest = async (requestUuid, decision, managerNote) => {
    try {
      await postRightworkAPI(API_review_timecard_change_request, {
        store_id: props.homeStore,
        timecard_change_request_uuid: requestUuid,
        decision,
        manager_note: managerNote,
      });
      toast.success(`Time entry request ${decision}`);
      if (timeEntriesDisplay === "by_employee" && selectedEmployee) {
        await fetchTimeCardsForEmployee(
          false,
          selectedPayPeriodDates[0],
          selectedEmployee.id
        );
      }
      await fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);
      fetchPayPeriods(false);
      invalidateOverviewCache();
    } catch (error) {
      toast.error(error.response?.data?.system?.message || "Unable to review request");
      throw error;
    }
  };


  const fetchTimeCardsForStore = async (showLoading, date) => {
    setIsLoading(showLoading);
    let api_params = {
      store_id: props.homeStore,
      date: date,
    };
    let api = API_get_timecards_for_store;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        // console.log("TIMECARDS", res.data.redux?.payload);
        setTimeEntries(res.data.redux?.payload?.timecards);
        setPaidBreakTrackingEnabled(res.data?.redux?.payload?.paid_break_tracking_enabled ?? false);
        setStoreChangeRequests(
          res.data?.redux?.payload?.timecard_change_requests || []
        );
        setIsLoading(false);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  console.log("TIMECARDS", timeEntries)

  const generatePaylocityExport = async (showLoading, date) => {
    setIsExporting(true);
    let api_params = {
      company_id: props.homeCompany,
      date: date,
      time_entries_hours_rounded_to_tenths: 'false', // Can be made configurable if needed
    };
    if (dateFilter.length > 0) {
      api_params.dates = dateFilter.join(",");
    }
    let api = API_export_timecards_paylocity;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        // Create a blob from the response and trigger download
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Build filename from the active date selection when present
        const datePayPeriod = getExportDateRangeLabel();
        const filename = `paylocity_import_${datePayPeriod}.csv`;

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        setIsExporting(false);
        toast.success("Export downloaded successfully!", { autoClose: 3000 });
      }
    } catch (error) {
      setIsExporting(false);
      toast.error("Export failed. Please try again.", { autoClose: 3000 });
      console.error("Export error:", error);
    }
  };

  const generateGustoExport = async (date) => {
    setIsExporting(true);
    const apiParams = {
      company_id: props.homeCompany,
      store_id: props.homeStore,
      date,
    };
    if (dateFilter.length > 0) {
      apiParams.dates = dateFilter.join(",");
    }

    try {
      const res = await getRightworkAPI(API_export_timecards_gusto, apiParams);
      if (res.status === 200) {
        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `gusto_time_entries_${getExportDateRangeLabel()}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("Gusto export downloaded successfully!", { autoClose: 3000 });
      }
    } catch (error) {
      toast.error("Gusto export failed. Please try again.", { autoClose: 3000 });
      console.error("Gusto export error:", error);
    } finally {
      setIsExporting(false);
    }
  };

  const renderGustoExportButton = () => (
    <Tooltip title="Gusto Company Export">
      <div
        className={`px-5 py-2 rounded-full flex items-center space-x-1 text-white ${
          isExporting
            ? "bg-emerald-600 cursor-not-allowed"
            : "bg-emerald-600 hover:bg-emerald-700 cursor-pointer"
        }`}
        onClick={() =>
          !isExporting && generateGustoExport(selectedPayPeriodDates[0])
        }
      >
        <div>
          {isExporting ? (
            <CircularProgress
              size="18px"
              style={{ color: "white", marginRight: "4px", marginTop: "5px" }}
            />
          ) : (
            <ExitToAppIcon />
          )}
        </div>
        <p>{isExporting ? "Exporting..." : "Export"}</p>
      </div>
    </Tooltip>
  );

  const fetchEmployeeList = async () => {
    let api_params = {
      store_id: props.homeStore,
    };
    let api = API_get_list_users;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        setEmployeeList(res.data.redux?.payload?.employees);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  const fetchRoles = async () => {
    let api_params = {
      store_id: props.homeStore,
    };
    let api = API_get_roles;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        setRolesList(res.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const handlePublishPayPeriod = async (payPeriodUUID, currentStatus) => {
    const newStatus = currentStatus === 'published' ? 'pending' : 'published';

    // Check if all entries are approved or denied when trying to publish
    // POS entries (is_pos_entry) are excluded from approval checks — they
    // can't be approved/denied via the timecard workflow.  However, open
    // POS shifts (currently_working) must still block publishing.
    if (newStatus === 'published') {
      const hasActiveWorkers = timeEntries.some(entry => entry.status === 'currently_working');
      if (hasActiveWorkers) {
        toast.error('Cannot publish while employees are clocked in', { autoClose: 5000 });
        return;
      }
      const hasPendingEntries = timeEntries.some((entry) =>
        !entry.is_pos_entry && ["pending", "currently_working", "auto_flag"].includes(entry.status)
      );
      if (hasPendingEntries) {
        toast.error('Cannot publish pay period until all time entries are approved or denied', { autoClose: 5000 });
        return;
      }
      if (storeChangeRequests.length > 0) {
        toast.error('Cannot publish pay period until all time entry requests are reviewed', { autoClose: 5000 });
        return;
      }
    }

    setIsPublishing(true);
    const actionText = newStatus === 'published' ? 'Publishing' : 'Unpublishing';

    try {
      toast.loading(`${actionText} Pay Period...`, { autoClose: false });

      const res = await postRightworkAPI(API_post_pay_period, {
        pay_period_uuid: payPeriodUUID,
        status: newStatus,
      });

      if (res.status === 200) {
        toast.dismiss();
        toast.success(`Pay Period ${newStatus === 'published' ? 'Published' : 'Unpublished'} Successfully`, { autoClose: 3000 });

        // Refresh pay periods to get updated status
        fetchPayPeriods(false);
      }
    } catch (error) {
      toast.dismiss();
      const errorMessage = error.response?.data?.error || `Error ${actionText.toLowerCase()} pay period`;
      toast.error(errorMessage, { autoClose: 5000 });
      console.error("Error publishing/unpublishing pay period:", error);
    } finally {
      setIsPublishing(false);
    }
  };


  const post_timecard = async (
    store_team_member_id,
    clocked_in_at,
    clocked_out_at,
    timecard_breaks,
    declared_cash_tips,
    timecard_uuid,
    role_id,
    manager_note,
    preserve_breaks
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      store_team_member_id: store_team_member_id,
      clocked_in_at: clocked_in_at,
      clocked_out_at: clocked_out_at,
      timecard_breaks: JSON.stringify(timecard_breaks),
      preserve_breaks: preserve_breaks,
      declared_cash_tips: declared_cash_tips,
      timecard_uuid: timecard_uuid,
      role_id: role_id,
      manager_note: manager_note,
    };

    try {
      toast.loading("Saving Time Entry...", { autoClose: false });

      const res = await postRightworkAPI(API_post_timecard, requestData);

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Time Entry Saved Successfully", { autoClose: 3000 });

        invalidateOverviewCache();

        fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);

        // Refresh pay periods to update total hours
        fetchPayPeriods(false);

        if (props.viewMode !== "byCompany") {
          fetchPayPeriodEmployees(false, selectedPayPeriodUUID);
        }

        if (selectedEmployee && selectedEmployee.id) {
          fetchTimeCardsForEmployee(
            false,
            selectedPayPeriodDates[0],
            selectedEmployee.id
          );
        }
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("Error Info", error.response?.data?.system?.data);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  // const delete_timecard = async (timecard_uuid) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: props.homeStore,
  //     timecard_uuid: timecard_uuid,
  //   };

  //   try {
  //     toast.loading("Deleting Time Entry...", { autoClose: false });

  //     const res = await postRightworkAPI(API_delete_timecard, requestData);

  //     if (res.status === 200) {
  //       toast.dismiss();
  //       toast.success("Time Entry Deleted Successfully", { autoClose: 3000 });

  //       fetchTimeCardsForStore(false);
  //     }
  //   } catch (error) {
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }

  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  const update_timecard_status = async (timecard_uuids, status) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      timecard_uuids: JSON.stringify(timecard_uuids),
      status: status,
    };

    try {
      toast.loading("Updating Time Entry Status...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_timecards_status,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Time Entry Status Updated Successfully", {
          autoClose: 3000,
        });

        invalidateOverviewCache();

        fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);

        // Refresh pay periods to update total hours
        fetchPayPeriods(false);

        // Refresh pay period employees to update hours/totals
        if (selectedPayPeriodUUID) {
          fetchPayPeriodEmployees(false, selectedPayPeriodUUID);
        }

        if (selectedEmployee && selectedEmployee.id) {
          fetchTimeCardsForEmployee(
            false,
            selectedPayPeriodDates[0],
            selectedEmployee.id
          );
        }
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error);
    }
  };

  const post_time_card_clock_out = async (
    timecard_uuid,
    clocked_out_at,
    stm_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      stm_id: stm_id,
      timecard_uuid: timecard_uuid,
      clocked_out_at: clocked_out_at,
    };

    try {
      toast.loading("Clocking Out Employee...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_timecard_clock_out,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Clocked Out Employee Successfully", { autoClose: 3000 });

        invalidateOverviewCache();

        fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);
        if (selectedEmployee && selectedEmployee.id) {
          fetchTimeCardsForEmployee(
            false,
            selectedPayPeriodDates[0],
            selectedEmployee.id
          );
        }
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const post_time_card_break_start = async (
    timecard_uuid,
    clocked_in_at,
    stm_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      stm_id: stm_id,
      timecard_uuid: timecard_uuid,
      clocked_in_at: clocked_in_at,
    };

    try {
      toast.loading("Starting Break For Employee...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_timecard_break_clock_in,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Break Started For Employee Successfully", {
          autoClose: 3000,
        });

        invalidateOverviewCache();

        fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);
        if (selectedEmployee && selectedEmployee.id) {
          fetchTimeCardsForEmployee(
            false,
            selectedPayPeriodDates[0],
            selectedEmployee.id
          );
        }
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };


  const post_time_card_break_end = async (
    timecard_break_uuid,
    clocked_out_at,
    stm_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      stm_id: stm_id,
      timecard_break_uuid: timecard_break_uuid,
      clocked_out_at: clocked_out_at,
    };

    try {
      toast.loading("Ending Break For Employee...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_timecard_break_clock_out,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Break Ended For Employee Successfully", {
          autoClose: 3000,
        });

        invalidateOverviewCache();

        fetchTimeCardsForStore(false, selectedPayPeriodDates[0]);
        if (selectedEmployee && selectedEmployee.id) {
          fetchTimeCardsForEmployee(
            false,
            selectedPayPeriodDates[0],
            selectedEmployee.id
          );
        }
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  // [POST] api/clock_info/post_pay_period_approval (company employee)
  // * store_id (auth)
  // * pay_period_uuid
  // * pay_period_approval_uuid [optional]
  // * status [optional]
  // * note [optional]
  const post_pay_period_approval = async (
    pay_period_uuid,
    pay_period_approval_uuid,
    status,
    note
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      pay_period_uuid: pay_period_uuid,
      pay_period_approval_uuid: pay_period_approval_uuid,
      status: status,
      note: note
    };

    try {
      toast.loading("Submitting...", { autoClose: false });

      const res = await postRightworkAPI(API_post_pay_period_approval, requestData);

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Submitted Successfully", { autoClose: 3000 });

        fetchPayPeriodEmployees(false, selectedPayPeriodUUID)
        if (selectedEmployee && selectedEmployee?.pay_period_approvals?.[0]?.uuid === pay_period_approval_uuid) {
          setSelectedEmployee(prev => ({
            ...prev,
            pay_period_approvals: [{
              ...prev.pay_period_approvals[0],
              status: status,
              note: note
            }]
          }));
        }

      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("Error Info", error.response?.data?.system?.data);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const handleSelectPayPeriod = (beginning_date, end_date, uuid) => {
    setShowTimeEntries(true);
    setSelectedPayPeriodDates([beginning_date, end_date]);
    fetchTimeCardsForStore(true, beginning_date);
    setSelectedPayPeriodUUID(uuid);
    fetchPayPeriodEmployees(true, uuid);
    setSearchInput("");
    setEmployeeSearchInput("");
  };

  const handleGoBack = () => {
    // Deselect the current period and go back to the pay period list
    setShowTimeEntries(false);
    setSelectedEmployee(null);
    setSelectedEmployeeTimeEntries([]);
    setSelectedEmployeeChangeRequests([]);
  };

  // Enhancing the status lookup to include both label and styling
  const statusStyles = {
    auto_approved: {
      label: props.timeEntriesEnabled ? "Auto-Approved" : "Passed",
      classes: "bg-emerald-50 border border-emerald-300 text-emerald-800",
    },
    auto_flag: {
      label: "Flagged",
      classes: "bg-fuchsia-50 border border-fuchsia-300 text-fuchsia-800",
    },
    approved: {
      label: "Approved",
      classes: "bg-blue-50 border border-blue-300 text-blue-800",
    },
    denied: {
      label: "Denied",
      classes: "bg-rose-50 border border-rose-300 text-red-800",
    },
    pending: {
      label: "Pending",
      classes: "bg-yellow-50 border border-yellow-300 text-yellow-800",
    },
    currently_working: {
      label: "In Progress",
      classes: "bg-violet-50 border border-violet-300 text-violet-800",
    },
  };

  const employeeApprovalStatusStyles = {
    approved: {
      label: "approved",
      classes: "border border-emerald-300 bg-emerald-50 text-emerald-800",
    },
    disputed: {
      label: "disputed",
      classes: "border border-rose-300 bg-rose-50 text-rose-800",
    },
    missed_approval: {
      label: "missed approval",
      classes: "border border-orange-300 bg-orange-50 text-orange-800",
    },
    pending_approval_initial: {
      label: "pending review",
      classes: "border border-amber-300 bg-amber-50 text-amber-800",
    },
    pending_approval_again: {
      label: "pending 2nd review",
      classes: "border border-amber-300 bg-amber-50 text-amber-800",
    },
  };

  // Existing states and hooks...
  const [nameFilter, setNameFilter] = useState([]);
  const [dateFilter, setDateFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [jobFilter, setJobFilter] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [employeeSearchInput, setEmployeeSearchInput] = useState("");
  const [allEntriesSort, setAllEntriesSort] = useState({ column: null, direction: "asc" });
  const [byEmployeeSort, setByEmployeeSort] = useState({ column: null, direction: "asc" });
  const [drillDownSort, setDrillDownSort] = useState({ column: null, direction: "asc" });

  // Assuming you've fetched timeEntries, now let's prepare dynamic filter options
  useEffect(() => {
    // This effect could be used to further manipulate timeEntries data if needed
  }, [timeEntries]);

  // Unique names for the Name filter dropdown
  const uniqueNames = [
    ...new Set(
      timeEntries?.map(
        (entry) =>
          `${entry?.store_team_member?.first_name} ${entry?.store_team_member?.last_name}`
      )
    ),
  ];

  // const filteredEmployeeList = employeeList.filter(
  //   (employee) => employee?.clock_pin !== null
  // );

  const filteredEmployeeList = employeeList

  // Block managers (but not admins) from creating, editing, or deleting their
  // OWN timecards when the store has block_manager_self_timecard_edit_enabled.
  // The backend enforces this too; this just hides the controls.
  const myMembership = props.storeOptions?.find(
    (membership) => membership.store === props.homeStore
  );
  const myStoreTeamMemberId = myMembership?.id;
  const selfTimecardEditBlocked =
    Boolean(props.blockManagerSelfTimecardEditEnabled) &&
    myMembership?.permission_type === "company_manager";
  const isOwnTimecardLocked = (entry) =>
    selfTimecardEditBlocked &&
    entry?.store_team_member?.id === myStoreTeamMemberId;

  const renderTimeEntryActions = (entry) => (
    <TimeEntryActions
      entry={entry}
      isPublished={payPeriods.find((period) => period.uuid === selectedPayPeriodUUID)?.status === "published"}
      isOwnTimecardLocked={isOwnTimecardLocked(entry)}
      onEdit={(timeEntry) => {
        setModalData(timeEntry);
        setModalEdit(true);
        handleOpen();
      }}
      update_timecard_status={update_timecard_status}
      post_time_card_break_end={post_time_card_break_end}
      post_time_card_break_start={post_time_card_break_start}
      post_time_card_clock_out={post_time_card_clock_out}
    />
  );

  //// console.log("FILTERED EMPLOYEE LIST", filteredEmployeeList);

  // const uniqueStoreTeamMembers = [];
  // const uniqueIds = new Set();

  // timeEntries.forEach((entry) => {
  //   const memberId = entry.store_team_member.id;
  //   if (!uniqueIds.has(memberId)) {
  //     uniqueIds.add(memberId);
  //     uniqueStoreTeamMembers.push(entry.store_team_member);
  //   }
  // });

  const getEntryBusinessDate = (entry) => {
    if (entry?.date) {
      return entry.date;
    }
    if (entry?.clocked_in_at) {
      return formatDate(new Date(entry.clocked_in_at).toLocaleDateString());
    }
    return null;
  };

  // Unique dates for the Date filter dropdown
  const uniqueDates = [
    ...new Set(
      timeEntries
        ?.map((entry) => getEntryBusinessDate(entry))
        ?.filter(Boolean)
    ),
  ];

  const getExportDateRangeLabel = () => {
    const activeDates = dateFilter.length
      ? dateFilter
      : selectedPayPeriodDates;

    if (!activeDates.length) {
      return "date_range";
    }

    const firstDate = activeDates[0];
    const lastDate = activeDates[activeDates.length - 1] || firstDate;

    return firstDate === lastDate ? firstDate : `${firstDate}_to_${lastDate}`;
  };

  const normalizeMultiSelectValue = (value) => {
    const rawValue = Array.isArray(value)
      ? value
      : typeof value === "string"
      ? value.split(",")
      : [value];

    return rawValue
      .filter((item) => item !== undefined && item !== null)
      .map((item) => String(item));
  };

  // Handlers for filter value changes
  const handleNameFilterChange = (event) => {
    const normalizedValue = normalizeMultiSelectValue(event.target.value);

    if (normalizedValue.includes("all")) {
      setNameFilter(
        nameFilter.length === uniqueNames.length ? [] : uniqueNames
      );
      return;
    }

    setNameFilter(normalizedValue.filter((item) => item !== ""));
  };

  const handleDateFilterChange = (event) => {
    const normalizedValue = normalizeMultiSelectValue(event.target.value);

    if (normalizedValue.includes("all")) {
      setDateFilter([]);
      return;
    }

    const nextDates = normalizedValue.filter((item) => item !== "");
    setDateFilter(nextDates.length === uniqueDates.length ? [] : nextDates);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const toggleSort = (sort, setSort, columnKey) => {
    if (sort.column === columnKey) {
      setSort({
        column: columnKey,
        direction: sort.direction === "asc" ? "desc" : "asc",
      });
    } else {
      setSort({ column: columnKey, direction: "asc" });
    }
  };

  // Department names come from rolesList (get_role_names); the serialized
  // entry.role only carries the role_type id.
  const roleIdToDepartment = {};
  rolesList.forEach((role) => {
    roleIdToDepartment[role.id] = role.role_type;
  });

  // Single-department companies don't need the Department column or filter
  const hasMultipleDepartments =
    new Set(rolesList.map((role) => role.role_type).filter(Boolean)).size > 1;

  const getEntryJobDisplay = (entry) => {
    // payroll_role is resolved backend-side to match the Paylocity export
    // (published-shift role wins over a stale clock-in role unless a manager
    // explicitly corrected the timecard). entry.role stays the raw role used
    // by the edit drawer.
    return entry?.payroll_role?.role_name || null;
  };

  const getEntryDepartment = (entry) =>
    entry?.payroll_role ? roleIdToDepartment[entry.payroll_role.id] || null : null;

  // Options for the Department and Job filter dropdowns
  const uniqueDepartments = [
    ...new Set(timeEntries?.map(getEntryDepartment)?.filter(Boolean)),
  ].sort();

  const uniqueJobs = [
    ...new Set(
      timeEntries?.map((entry) => entry?.payroll_role?.role_name)?.filter(Boolean)
    ),
  ].sort();

  const getEntrySortValue = (entry, columnKey) => {
    switch (columnKey) {
      case "name":
        return `${entry?.store_team_member?.first_name} ${entry?.store_team_member?.last_name}`.toLowerCase();
      case "job":
        return (getEntryJobDisplay(entry) || "").toLowerCase();
      case "department":
        return (getEntryDepartment(entry) || "").toLowerCase();
      case "date":
      case "timesheet":
        // Sort chronologically by clock-in; legacy entries only carry a date
        if (entry?.clocked_in_at) {
          return new Date(entry.clocked_in_at).getTime();
        }
        return entry?.date ? new Date(entry.date).getTime() : 0;
      case "paid_hours":
        return Number(entry?.paid_hours ?? 0);
      case "unpaid_breaks":
        return props.timeEntriesEnabled
          ? Number(entry?.break_minutes ?? 0)
          : hoursToMinutes(Number(entry?.unpaid_break_time ?? 0));
      case "paid_breaks":
        return Number(entry?.paid_break_minutes ?? 0);
      case "earnings":
        return Number(entry?.total_pay ?? 0);
      case "status":
        return entry?.clocked_out_at
          ? entry?.status ?? ""
          : "currently_working";
      default:
        return 0;
    }
  };

  const sortEntries = (entries, sort) => {
    if (!sort.column || !entries) {
      return entries;
    }
    return [...entries].sort((a, b) => {
      const valueA = getEntrySortValue(a, sort.column);
      const valueB = getEntrySortValue(b, sort.column);
      const cmp =
        typeof valueA === "string"
          ? valueA.localeCompare(valueB)
          : valueA - valueB;
      return sort.direction === "asc" ? cmp : -cmp;
    });
  };

  const renderSortableHeader = (col, sort, setSort) => (
    <th
      key={col.key}
      scope="col"
      className={`${col.className} cursor-pointer select-none hover:text-slate-700`}
      onClick={() => toggleSort(sort, setSort, col.key)}
    >
      <div className="flex items-center gap-1">
        {col.label}
        {sort.column === col.key &&
          (sort.direction === "asc" ? (
            <ArrowUpwardIcon style={{ fontSize: "14px" }} />
          ) : (
            <ArrowDownwardIcon style={{ fontSize: "14px" }} />
          ))}
      </div>
    </th>
  );

  const firstEntryThClassName =
    "flex-1 py-3 pl-5 pr-3 text-left text-xs font-bold uppercase text-slate-500";
  const entryThClassName =
    "flex-1 px-3 py-3 text-left text-xs font-bold uppercase text-slate-500";

  const entryTableColumns = [
    { key: "name", label: "Name", className: firstEntryThClassName },
    ...(hasMultipleDepartments
      ? [{ key: "department", label: "Dept", className: entryThClassName }]
      : []),
    { key: "job", label: "Job", className: entryThClassName },
    { key: "date", label: "Date", className: entryThClassName },
    { key: "timesheet", label: "Timesheet", className: entryThClassName },
    { key: "paid_hours", label: "Hours Paid", className: entryThClassName },
    { key: "unpaid_breaks", label: "Unpaid Breaks", className: entryThClassName },
    ...(paidBreakTrackingEnabled
      ? [{ key: "paid_breaks", label: "Paid Breaks", className: entryThClassName }]
      : []),
    ...(!props.timeEntriesEnabled && props.payrollWagesEnabled
      ? [{ key: "earnings", label: "Earnings", className: entryThClassName }]
      : []),
    { key: "status", label: "Status", className: entryThClassName },
  ];

  const filteredTimeEntries = timeEntries.filter((entry) => {
    const fullName = `${entry?.store_team_member?.first_name} ${entry?.store_team_member?.last_name}`;
    const entryDate = getEntryBusinessDate(entry);

    // Compute the display status (matching the logic in the render section)
    const displayStatus = entry.clocked_out_at ? entry.status : "currently_working";

    // Apply search filter (matches name or date; status has its own dropdown)
    const searchQuery = searchInput.trim().toLowerCase();
    const matchesSearch = searchQuery
      ? [fullName, entryDate]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(searchQuery))
      : true;
    // Apply name filter
    const matchesName = nameFilter.length ? nameFilter.includes(fullName) : true;
    // Apply date filter
    const matchesDate = dateFilter.length ? dateFilter.includes(entryDate) : true;
    // Apply status filter
    // When filtering by "approved", match all approved variants (approved, auto_approved, manual_approved)
    // When filtering by "denied", match all denied variants (denied, manual_denied)
    const matchesStatus = statusFilter
      ? (statusFilter === "approved"
          ? (displayStatus === "approved" || displayStatus === "auto_approved" || displayStatus === "manual_approved")
          : (statusFilter === "denied"
              ? (displayStatus === "denied" || displayStatus === "manual_denied")
              : (statusFilter === "no_status"
                  ? (!displayStatus)
                  : displayStatus === statusFilter)))
      : true;
    // Apply department filter (inactive when the dropdown is hidden)
    const matchesDepartment =
      departmentFilter && hasMultipleDepartments
        ? getEntryDepartment(entry) === departmentFilter
        : true;
    // Apply job filter
    const matchesJob = jobFilter
      ? entry?.payroll_role?.role_name === jobFilter
      : true;

    return (
      matchesSearch &&
      matchesName &&
      matchesDate &&
      matchesStatus &&
      matchesDepartment &&
      matchesJob
    );
  });

  const filteredTimeEntriesForApproveAll = filteredTimeEntries.filter(
    (entry) => {
      return !entry.is_pos_entry && (entry.status === "pending" || entry.status === "auto_flag");
    }
  );

  let filteredTimeEntriesUUIDs = [];

  filteredTimeEntriesForApproveAll.forEach((timeEntry) =>
    filteredTimeEntriesUUIDs.push(timeEntry.uuid)
  );

  const getEmployeeSortValue = (employee, columnKey) => {
    switch (columnKey) {
      case "name":
        return (employee?.full_name || "").toLowerCase();
      case "payable_hours":
        return Number(employee?.timecard_summary_data?.payable_hours ?? 0);
      case "total_pay":
        return Number(employee?.timecard_summary_data?.total_pay ?? 0);
      case "tips":
        return (
          tipList.find((tip) => tip.store_team_member?.id === employee?.id)
            ?.total_tip_amount_cents || 0
        );
      case "approval":
        return employee?.pay_period_approvals?.[0]?.status || "";
      default:
        return 0;
    }
  };

  const displayedPayPeriodEmployees = (() => {
    const searchQuery = employeeSearchInput.trim().toLowerCase();
    let employees = payPeriodEmployees || [];
    if (searchQuery) {
      employees = employees.filter((employee) =>
        (employee?.full_name || "").toLowerCase().includes(searchQuery)
      );
    }
    if (byEmployeeSort.column) {
      employees = [...employees].sort((a, b) => {
        const valueA = getEmployeeSortValue(a, byEmployeeSort.column);
        const valueB = getEmployeeSortValue(b, byEmployeeSort.column);
        const cmp =
          typeof valueA === "string"
            ? valueA.localeCompare(valueB)
            : valueA - valueB;
        return byEmployeeSort.direction === "asc" ? cmp : -cmp;
      });
    }
    return employees;
  })();

  const employeeSummaryColumns = [
    { key: "name", label: "Name", className: firstEntryThClassName },
    { key: "payable_hours", label: "Hours Paid", className: entryThClassName },
    ...(!props.timeEntriesEnabled && props.payrollWagesEnabled
      ? [{ key: "total_pay", label: "Cost", className: entryThClassName }]
      : []),
    ...(props.payrollProvider === "payroll_provider_paylocity"
      ? [{ key: "tips", label: "Tips Earned", className: entryThClassName }]
      : []),
    ...(props.payrollEmployeeReviewEnabled
      ? [{ key: "approval", label: "Employee Approval", className: entryThClassName }]
      : []),
  ];

  let employeeTimeEntriesUUIDs = [];

  selectedEmployeeTimeEntries.forEach((timeEntry) => {
    if (!timeEntry.is_pos_entry) {
      employeeTimeEntriesUUIDs.push(timeEntry.uuid);
    }
  });

  function handleNameChange(event) {
    const selectedStoreTeamMemberId = event.target.value;
    const selectedStoreTeamMember = filteredEmployeeList.find(
      (member) => member.id === selectedStoreTeamMemberId
    );
    setModalData({
      ...modalData,
      store_team_member: selectedStoreTeamMember,
    });
  }

  function handleRoleChange(event) {
    const selectedRoleId = event.target.value;
    const selectedRole = selectedRoleId
      ? rolesList.find((role) => role.id === selectedRoleId)
      : null;
    setModalData({
      ...modalData,
      role: selectedRole,
    });
  }


  function handleDateTimeChange(name, value) {
    // A shift-boundary edit never relocates or truncates stored break events.
    // Like the break pickers, a picked time means that exact minute: drop
    // seconds the picker would otherwise carry over, unseen, from the old value.
    const ms = value?.getTime?.();
    const picked = Number.isFinite(ms) ? new Date(Math.floor(ms / 60000) * 60000) : value;
    setModalData(previous => ({ ...previous, [name]: picked }));
  }

  function handleBreaksChange(breaks) {
    // Breaks the manager edited are saved exactly as entered.
    setModalData(previous => ({ ...previous, timecard_breaks: breaks, breaks_edited: true }));
  }

  function handleTipChange(event) {
    setModalData({
      ...modalData,
      declared_cash_tips: event.target.value,
    });
  }

  function getValidationErrors() {
    const errors = {};
    const showClockOut = !modalEdit || modalData.clocked_out_at;

    if (!modalData.store_team_member?.id) {
      errors.employee = "Please select an employee";
    }

    if (!modalData.clocked_in_at_date_time || isNaN(modalData.clocked_in_at_date_time.getTime())) {
      errors.clockIn = "Please enter a valid clock in time";
    }

    if (showClockOut) {
      if (!modalData.clocked_out_at_date_time || isNaN(modalData.clocked_out_at_date_time.getTime())) {
        errors.clockOut = "Please enter a valid clock out time";
      } else if (
        modalData.clocked_in_at_date_time &&
        !isNaN(modalData.clocked_in_at_date_time.getTime()) &&
        modalData.clocked_out_at_date_time.getTime() <= modalData.clocked_in_at_date_time.getTime()
      ) {
        errors.clockOut = "Clock out must be after clock in";
      }

    }

    const shiftStart = modalData.clocked_in_at_date_time?.getTime();
    const shiftEnd = showClockOut ? modalData.clocked_out_at_date_time?.getTime() : null;
    if (showClockOut && (!modalEdit || modalData.breaks_edited)) {
      const breakErrors = validateBreaks(modalData.timecard_breaks, shiftStart, shiftEnd);
      if (Object.keys(breakErrors).length > 0) errors.breaks = breakErrors;
    } else if (modalEdit) {
      // Untouched breaks are kept as recorded; only a shift-time change can
      // conflict with them. Unchanged legacy intervals never block a save.
      const end = modalData.clocked_out_at ? shiftEnd : null;
      if (shiftStart !== new Date(modalData.clocked_in_at).getTime() ||
          end !== (modalData.clocked_out_at ? new Date(modalData.clocked_out_at).getTime() : null)) {
        const message = breakBoundsError(modalData.timecard_breaks, shiftStart, end);
        if (message) errors.breakBounds = message;
      }
    }

    return errors;
  }

  function handleSubmit() {
    setSubmitted(true);
    const errors = getValidationErrors();
    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the errors before saving");
      return;
    }
    if (
      selfTimecardEditBlocked &&
      modalData.store_team_member?.id === myStoreTeamMemberId
    ) {
      toast.error(
        "Managers aren't allowed to edit their own time entries at this location. Please ask an admin or another manager to make this change."
      );
      return;
    }
    post_timecard(
      modalData.store_team_member?.id,
      modalData.clocked_in_at_date_time.getTime(),
      !modalEdit || modalData.clocked_out_at ? modalData.clocked_out_at_date_time.getTime() : null,
      modalData.timecard_breaks,
      modalData.declared_cash_tips ? modalData.declared_cash_tips : "0",
      modalData.uuid,
      modalData.role?.id,
      modalData.manager_note,
      modalEdit && !modalData.breaks_edited
    );
    handleClose();
  }

  // Function to convert data to CSV format
  const convertToCSV = (data) => {
    const csvRows = [];
    // Headers
    const headers = [
      "Name",
      "Date",
      "Timesheet",
      "Hours Paid",
      "Unpaid Breaks",
      ...(paidBreakTrackingEnabled ? ["Paid Breaks"] : []),
      "Status",
    ];
    csvRows.push(headers.join(","));

    // Filter out denied timecards from export (both old and new format)
    const exportData = data.filter(entry => entry.status !== 'denied' && entry.status !== 'manual_denied');

    // Values
    for (const entry of exportData) {
      // Use pre-calculated values from backend API
      const paidHours = entry.paid_hours ?? 0;
      const breakMinutes = props.timeEntriesEnabled
        ? (entry.break_minutes ?? 0)
        : hoursToMinutes(Number(entry.unpaid_break_time));
      const paidBreakMinutes = entry.paid_break_minutes ?? 0;
      entry["clocked_in_at_date_time"] = new Date(entry.clocked_in_at);
      entry["clocked_out_at_date_time"] = new Date(
        entry.clocked_out_at ? entry.clocked_out_at : new Date().getTime()
      );
      entry["status"] = entry.clocked_out_at
        ? entry.status
        : "currently_working";
      entry["sub_status"] =
        !entry.clocked_out_at &&
        (entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]
          ?.clocked_out_at ||
          entry.timecard_breaks?.length === 0)
          ? "Working"
          : !entry.clocked_out_at &&
            !entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]
              ?.clocked_out_at
          ? (entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]?.is_paid ? "On Paid Break" : "On Break")
          : null;

      const values = [
        `${entry.store_team_member.first_name} ${entry.store_team_member.last_name}`,
        `${getEntryBusinessDate(entry) || ""}`,
        `${new Date(entry.clocked_in_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })} - ${new Date(entry.clocked_out_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`,
        `${paidHours}hrs`,
        `${breakMinutes}min`,
        ...(paidBreakTrackingEnabled ? [`${paidBreakMinutes}min`] : []),
        `${entry.status}`,
      ];
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  // Function to download CSV file
  const downloadCSV = () => {
    const csvData = convertToCSV(timeEntries);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const datePayPeriod = getExportDateRangeLabel();
    const filename = `time_entries_${datePayPeriod}.csv`; // Add datePayPeriod to filename
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Function to export tips to CSV using backend endpoint
  const exportTipsToCSV = async () => {
    if (tipList.length === 0) {
      toast.warning("No tips calculated yet. Please calculate tips first.", { autoClose: 3000 });
      return;
    }

    setIsExporting(true);
    let api_params = {
      company_id: props.homeCompany,
      date: selectedPayPeriodDates[0],
    };
    let api = API_export_tips_paylocity;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        // Create a blob from the response and trigger download
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Build filename from pay period dates
        const datePayPeriod = `${selectedPayPeriodDates[0]}_to_${selectedPayPeriodDates[1]}`;
        const filename = `tips_export_${datePayPeriod}.csv`;

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        setIsExporting(false);
        toast.success("Tips export downloaded successfully!", { autoClose: 3000 });
      }
    } catch (error) {
      setIsExporting(false);
      toast.error("Tips export failed. Please try again.", { autoClose: 3000 });
      console.error("Tips export error:", error);
    }
  };


  const aggregatedSummary = selectedEmployeeSummaryList?.reduce(
    (acc, current) => {
      return {
        hours_scheduled: acc.hours_scheduled + Number(current.hours_scheduled),
        hours_worked: acc.hours_worked + Number(current.hours_worked),
        wages_scheduled: acc.wages_scheduled + Number(current.wages_scheduled),
        wages_earned: acc.wages_earned + Number(current.wages_earned),
      };
    },
    {
      hours_scheduled: 0,
      hours_worked: 0,
      wages_scheduled: 0,
      wages_earned: 0,
    }
  );

  const storeChangeRequestsAlert = storeChangeRequests.length > 0 && (
    <div className="mt-6">
      <button
        type="button"
        aria-haspopup="dialog"
        onClick={() => setStoreChangeRequestsModalOpen(true)}
        className="inline-flex max-w-2xl items-center gap-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-left hover:border-amber-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-200 sm:max-w-full sm:flex-col sm:items-start sm:gap-2"
      >
        <div className="flex items-center gap-3">
          <WarningIcon className="text-amber-600" />
          <div>
            <p className="text-sm font-semibold text-slate-900">
              {storeChangeRequests.length} pending time entry {storeChangeRequests.length === 1 ? "request" : "requests"}
            </p>
            <p className="mt-0.5 text-xs text-slate-600">
              Employee-submitted changes are waiting for manager review.
            </p>
          </div>
        </div>
        <span className="text-sm font-semibold text-violet-700">
          Review requests
        </span>
      </button>
      <Modal
        open={storeChangeRequestsModalOpen}
        onClose={() => setStoreChangeRequestsModalOpen(false)}
        aria-labelledby="timecard-change-requests-title"
      >
        <div className="absolute left-1/2 top-1/2 flex max-h-[85vh] w-[min(56rem,calc(100%-2rem))] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl bg-white shadow-xl focus:outline-none">
          <div className="flex items-start justify-between border-b border-slate-200 px-6 py-5">
            <div>
              <h2
                id="timecard-change-requests-title"
                className="text-xl font-semibold text-slate-900"
              >
                Review time entry requests
              </h2>
              <p className="mt-1 text-sm text-slate-500">
                {storeChangeRequests.length} employee {storeChangeRequests.length === 1 ? "request is" : "requests are"} waiting for review.
              </p>
            </div>
            <button
              type="button"
              aria-label="Close time entry requests"
              onClick={() => setStoreChangeRequestsModalOpen(false)}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-200"
            >
              <ClearIcon sx={{ fontSize: 20 }} />
            </button>
          </div>
          <div className="overflow-y-auto p-6 sm:p-4">
            <TimecardChangeRequestsPanel
              requests={storeChangeRequests}
              onReview={reviewTimecardChangeRequest}
              readOnly={!selectedPayPeriodIsMutable}
              showEmployeeName
              rolesList={rolesList}
              showHeading={false}
            />
          </div>
        </div>
      </Modal>
    </div>
  );


  if (showCustomRange) {
    const leaveCustomRange = () => { setShowCustomRange(false); handleGoBack(); };
    return (
      <ThemeProvider theme={timeClockTheme}>
        <TimeEntriesHeader
          title="Back to Pay Periods"
          storeOptions={props.storeOptions}
          homeStore={props.homeStore}
          storeNames={props.storeNames}
          change_home_store={props.change_home_store}
          setCurrentTab={props.setCurrentTab}
          handleGoBack={leaveCustomRange}
          showTimeEntries={true}
          showSettings={false}
          // The gear leaves the report for the settings view.
          setShowSettings={(update) => { leaveCustomRange(); setShowSettings(update); }}
          timeEntriesEnabled={props.timeEntriesEnabled}
          payrollEnabled={props.payrollEnabled}
        />
        <TimecardRangeReport
          key={props.homeStore}
          storeId={props.homeStore}
          storeName={props.storeNames?.find(store => store.id === props.homeStore)?.store_name || "Current location"}
          hoursRoundedToTenths={props.timeEntriesHoursRoundedToTenths}
          rolesList={rolesList}
        />
      </ThemeProvider>
    );
  }

  return (
    <>
      {!isLoading ? (
        !showSettings ? (
          <div>
            {showTimeEntries ? (
              <div>
                <div>
                  <div>
                    <TimeEntriesHeader
                      title="Back to Pay Periods"
                      storeOptions={props.storeOptions}
                      homeStore={props.homeStore}
                      storeNames={props.storeNames}
                      change_home_store={props.change_home_store}
                      setCurrentTab={props.setCurrentTab}
                      handleGoBack={handleGoBack}
                      showTimeEntries={showTimeEntries}
                      setShowTimeEntries={setShowTimeEntries}
                      showSettings={showSettings}
                      setShowSettings={setShowSettings}
                      timeEntriesEnabled={props.timeEntriesEnabled}
                      payrollEnabled={props.payrollEnabled}
                    />
                  </div>
                  {timeEntriesDisplay === "by_employee" ? (
                    <>
                      {!selectedEmployee ? (
                        <div>
                          <div className="px-6 mt-8">
                            <div className="flex justify-between">
                              <div>
                                <h1 className="text-xl font-bold text-slate-900">
                                  By Employee
                                </h1>
                                <h3 className="mt-1 text-slate-500">
                                  {`${formatDateReadable(
                                    selectedPayPeriodDates[0]
                                  )} to ${formatDateReadable(
                                    selectedPayPeriodDates[1]
                                  )}`}
                                </h3>
                                <TimeEntriesViewSwitcher
                                  value={timeEntriesDisplay}
                                  onChange={setTimeEntriesDisplay}
                                />
                              </div>
                              <div className="flex items-center space-x-3">
                                {/* {props.timeEntriesEnabled &&
                                <Tooltip title="Add new time entry">
                                  <div
                                    className="h-10 w-10 rounded-full bg-violet-700 hover:bg-violet-800 text-white text-whiten flex items-center justify-center cursor-pointer"
                                    onClick={() => {
                                      setModalData(default_data);
                                      setModalEdit(false);
                                      handleOpen();
                                    }}
                                  >
                                    <AddIcon />
                                  </div>
                                </Tooltip>
                              } */}

                                <Tooltip title="Compliance Audit">
                                  <div
                                    className="h-10 w-10 rounded-full bg-slate-600 hover:bg-slate-700 text-white flex items-center justify-center cursor-pointer"
                                    onClick={() => setComplianceAuditOpen(true)}
                                  >
                                    <GavelIcon style={{ fontSize: "18px" }} />
                                  </div>
                                </Tooltip>

                                {/* A location that pools tips gets its tip workflow, and payroll its file, from Time & Payroll > Tips. */}
                                {props.tipCalculatorEnabled && !props.tipPoolingEnabled &&
                                  <Tooltip title="Calculate tips for employees">
                                    <div
                                      className="px-5 py-2 rounded-full bg-violet-700 hover:bg-violet-800 flex items-center space-x-1 text-white cursor-pointer"
                                      onClick={() => setTipCalculatorOpen(true)}
                                    >
                                      <div>
                                        <AttachMoneyIcon />
                                      </div>
                                      <p>Calculate Tips</p>
                                    </div>
                                  </Tooltip>
                                }

                                {/* Kept alongside the Tips page export: whether every company location
                                    has moved to tip pooling cannot be judged from the locations this
                                    user can see, and a location still on the calculator needs this. */}
                                {props.payrollProvider === "payroll_provider_paylocity" && (
                                  tipList.length > 0 ? (
                                    <Tooltip title="Export tips for all company stores">
                                      <div
                                        className={`px-5 py-2 rounded-full flex items-center space-x-1 text-white ${
                                          isExporting
                                            ? 'bg-orange-600 cursor-not-allowed'
                                            : 'bg-orange-600 hover:bg-orange-700 cursor-pointer'
                                        }`}
                                        onClick={() => !isExporting && exportTipsToCSV()}
                                      >
                                        <div>
                                          {isExporting ? (
                                            <CircularProgress size="18px" style={{ color: 'white', marginRight: "4px", marginTop: "5px" }} />
                                          ) : (
                                            <ExitToAppIcon />
                                          )}
                                        </div>
                                        <p>{isExporting ? 'Exporting...' : 'Company Tips Export'}</p>
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Calculate tips before exporting company tips">
                                      <div className="px-5 py-2 rounded-full bg-slate-200 flex items-center space-x-1 text-slate-400 cursor-not-allowed">
                                        <div>
                                          <ExitToAppIcon />
                                        </div>
                                        <p>Company Tips Export</p>
                                      </div>
                                    </Tooltip>
                                  )
                                )}

                                {props.payrollProvider !== "payroll_provider_paylocity" && props.payrollProvider !== "payroll_provider_qbo" && props.payrollProvider !== "payroll_provider_gusto" && (
                                  !timeEntries.some((entry) =>
                                    entry.status === "currently_working" ||
                                    (!entry.is_pos_entry && ["pending", "auto_flag"].includes(entry.status))
                                  ) ? (
                                    <Tooltip title="Download all time entries to a .csv file">
                                      <div
                                        className="px-5 py-2 rounded-full bg-orange-600 hover:bg-orange-700 flex items-center space-x-1 text-white cursor-pointer"
                                        onClick={downloadCSV}
                                      >
                                        <div>
                                          <DownloadIcon />
                                        </div>
                                        <p>Download</p>
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Cannot download until all time entries are approved or denied">
                                      <div className="px-5 py-2 rounded-full bg-slate-200 flex items-center space-x-1 text-slate-400 cursor-not-allowed">
                                        <div>
                                          <DownloadIcon />
                                        </div>
                                        <p>Download</p>
                                      </div>
                                    </Tooltip>
                                  )
                                )}

                                {props.payrollProvider === "payroll_provider_gusto" &&
                                  renderGustoExportButton()}

                                {props.timeEntriesEnabled && (() => {
                                  const selectedPayPeriod = payPeriods.find(pp => pp.uuid === selectedPayPeriodUUID);
                                  const isPublished = selectedPayPeriod?.status === 'published';
                                  const canUnpublish = selectedPayPeriod?.can_unpublish;
                                  const hasActiveWorkers = timeEntries.some(entry => entry.status === 'currently_working');
                                  const hasPendingEntries = timeEntries.some((entry) =>
                                    !entry.is_pos_entry && ["pending", "currently_working", "auto_flag"].includes(entry.status)
                                  );
                                  const hasPendingChangeRequests = storeChangeRequests.length > 0;
                                  const buttonDisabled = isPublishing || !selectedPayPeriod || (!isPublished && (hasPendingEntries || hasActiveWorkers || hasPendingChangeRequests));

                                  // If published but user can't unpublish, just show a badge instead of a button
                                  if (isPublished && !canUnpublish) {
                                    const publishedByName = selectedPayPeriod?.published_by_name;
                                    const tooltipText = publishedByName
                                      ? `This pay period was published by ${publishedByName}`
                                      : "This pay period was published by another user";

                                    return (
                                      <Tooltip title={tooltipText}>
                                        <div className="px-5 py-2 rounded-full bg-orange-100 text-orange-700 flex items-center space-x-1">
                                          <div>
                                            <CheckIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                          </div>
                                          <p>Published</p>
                                        </div>
                                      </Tooltip>
                                    );
                                  }

                                  let tooltipText = isPublished
                                    ? "Click to unpublish this pay period"
                                    : hasPendingChangeRequests
                                      ? "Cannot publish until all time entry requests are reviewed"
                                      : hasPendingEntries
                                      ? "Cannot publish until all time entries are approved or denied"
                                      : hasActiveWorkers
                                        ? "Cannot publish while employees are clocked in"
                                        : "Publish this pay period to lock it from editing";

                                  return (
                                    <Tooltip title={tooltipText}>
                                      <div
                                        className={`px-5 py-2 rounded-full flex items-center space-x-1 ${
                                          buttonDisabled
                                            ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                                            : isPublished
                                              ? 'bg-orange-600 hover:bg-orange-700 text-white cursor-pointer'
                                              : 'bg-emerald-600 hover:bg-emerald-700 text-white cursor-pointer'
                                        }`}
                                        onClick={() => {
                                          if (!buttonDisabled) {
                                            handlePublishPayPeriod(selectedPayPeriodUUID, selectedPayPeriod.status);
                                          }
                                        }}
                                      >
                                        <div>
                                          {isPublished ? (
                                            <LockOpenIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                          ) : (
                                            <LockIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                          )}
                                        </div>
                                        <p>{isPublishing ? 'Processing...' : (isPublished ? 'Unpublish' : 'Publish')}</p>
                                      </div>
                                    </Tooltip>
                                  );
                                })()}
                              </div>
                            </div>
                            {storeChangeRequestsAlert}
                          </div>
                          <div className="mt-4 w-full px-6">
                            <div className="mb-4 w-72">
                                    <TextField
                                      fullWidth
                                      placeholder="Search by name..."
                                      value={employeeSearchInput}
                                      onChange={(e) =>
                                        setEmployeeSearchInput(e.target.value)
                                      }
                                      size="small"
                                      InputProps={{
                                        startAdornment: (
                                          <SearchIcon
                                            sx={{
                                              mr: 1,
                                              color: "text.secondary",
                                              fontSize: 20,
                                            }}
                                          />
                                        ),
                                        endAdornment: employeeSearchInput && (
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              setEmployeeSearchInput("")
                                            }
                                          >
                                            <ClearIcon fontSize="small" />
                                          </IconButton>
                                        ),
                                      }}
                                      sx={{
                                        "& .MuiOutlinedInput-root": {
                                          height: "40px",
                                          backgroundColor: "white",
                                          borderRadius: "8px",
                                          fontSize: "14px",
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#6d28d9",
                                          },
                                        },
                                      }}
                                    />
                            </div>
                            <div className="min-w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
                              <div className="inline-block min-w-full align-middle">
                                <div className="overflow-hidden">
                                  <table className="min-w-full divide-y divide-slate-200">
                                    <thead className="bg-slate-50">
                                      <tr>
                                        {employeeSummaryColumns.map((col) =>
                                          renderSortableHeader(
                                            col,
                                            byEmployeeSort,
                                            setByEmployeeSort
                                          )
                                        )}
                                        <th
                                          scope="col"
                                          className="relative w-1/12 py-3 pl-3 pr-5 text-right text-xs font-bold uppercase text-slate-500"
                                        ></th>
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-200 bg-white">
                                      {displayedPayPeriodEmployees?.map(
                                        (employee, i) => {
                                          return (
                                            <tr
                                              key={i}
                                              className="group cursor-pointer bg-white transition-colors hover:bg-slate-50"
                                              onClick={() => {
                                                setSelectedEmployee(employee);
                                                fetchTimeCardsForEmployee(
                                                  true,
                                                  selectedPayPeriodDates[0],
                                                  employee?.id
                                                );
                                              }}
                                            >
                                              <td className="whitespace-nowrap py-5 pl-6 pr-3 text-sm">
                                                <div>{employee?.full_name}</div>
                                              </td>
                                              {/* <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                            <div>
                                              4
                                            </div>
                                          </td> */}
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                <div>
                                                  {employee?.timecard_summary_data?.payable_hours?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}
                                                </div>
                                              </td>
                                              {!props.timeEntriesEnabled &&
                                                props.payrollWagesEnabled && (
                                                  <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                    <div>
                                                      $
                                                      {(employee?.timecard_summary_data?.total_pay).toLocaleString(
                                                        "en-US",
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }
                                                      )}
                                                    </div>
                                                  </td>
                                                )}
                                              {props.payrollProvider === "payroll_provider_paylocity" && (
                                                <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                  <div className={tipList.length === 0 ? "text-slate-500 italic" : ""}>
                                                    {getTipsDisplay(employee?.id)}
                                                  </div>
                                                </td>
                                              )}
                                              {props.payrollEmployeeReviewEnabled &&
                                                <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                  <div className={`w-fit rounded px-2 py-1 ${employeeApprovalStatusStyles?.[employee?.pay_period_approvals?.[0]?.status]?.classes}`}>
                                                    {employeeApprovalStatusStyles?.[employee?.pay_period_approvals?.[0]?.status]?.label}
                                                  </div>
                                                </td>
                                              }
                                              <td className="relative whitespace-nowrap py-5 pl-3 pr-6 text-right text-sm font-medium flex items-center justify-end">
                                                <div className="text-slate-500 mt-1">
                                                  <ChevronRightIcon />
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                  {payPeriodEmployees.length === 0 && (
                                    <div className="flex w-full justify-center border-t border-slate-200 px-6 py-10">
                                      <div className="flex flex-col items-center">
                                        <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center">
                                          <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                                        </div>
                                        <p className="mt-3 text-sm text-slate-400">
                                          No employees currently have time entries
                                          for this pay period
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="mx-auto mt-8 w-full max-w-6xl pb-8">
                          <div
                            className="flex items-center text-slate-500 hover:text-slate-600 cursor-pointer px-6"
                            onClick={() => {
                              setSelectedEmployee(null);
                              setSelectedEmployeeTimeEntries([]);
                              setSelectedEmployeeChangeRequests([]);
                            }}
                          >
                            <div>
                              <ChevronLeftIcon
                                style={{
                                  fontSize: "18px",
                                  marginBottom: "3px",
                                }}
                              />
                            </div>
                            <p className="text-sm">Back to Employee List</p>
                          </div>
                          <div className="px-6 mt-8 relative">
                            <div className="flex justify-between">
                              <div>
                                <h1 className="text-xl font-bold text-slate-900">
                                  {selectedEmployee?.full_name}
                                </h1>
                                <h3 className="mt-2 text-slate-500">
                                  {`${formatDateReadable(
                                    selectedPayPeriodDates[0]
                                  )} to ${formatDateReadable(
                                    selectedPayPeriodDates[1]
                                  )}`}
                                </h3>
                              </div>
                              <div className="flex items-center space-x-3">
                              </div>
                            </div>
                            {props.payrollEmployeeReviewEnabled &&
                              <div className="absolute top-0 right-6">
                                <TimeEntriesReviewCardManager
                                  selectedPayPeriodUUID={selectedPayPeriodUUID}
                                  selectedEmployee={selectedEmployee}
                                  post_pay_period_approval={post_pay_period_approval}
                                  numOfTimeEntries={selectedEmployeeTimeEntries?.length}
                                  timeEntriesHoursRoundedToTenths={props.timeEntriesHoursRoundedToTenths}
                                />
                              </div>
                            }
                          </div>
                          {selectedEmployeeChangeRequests.length > 0 && (
                            <div className="mt-6 px-6">
                              <TimecardChangeRequestsPanel
                                requests={selectedEmployeeChangeRequests}
                                onReview={reviewTimecardChangeRequest}
                                readOnly={!selectedPayPeriodIsMutable}
                                rolesList={rolesList}
                              />
                            </div>
                          )}
                          <div className="mt-8 px-6 flex items-center space-x-6">
                            <div className="px-4 py-3 border border-slate-100 rounded-lg w-[200px]">
                              <p className="text-xs text-slate-900 font-semibold">
                                Scheduled
                              </p>
                              <div className="mt-2 flex space-x-10">
                                <div>
                                  <p className="text-xxs text-slate-500">
                                    Hours
                                  </p>
                                  <p className="text-lg text-slate-900">
                                    {aggregatedSummary?.hours_scheduled?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}
                                  </p>
                                </div>
                                {!props.timeEntriesEnabled &&
                                  props.payrollWagesEnabled && (
                                    <div>
                                      <p className="text-xxs text-slate-500">
                                        Earnings
                                      </p>
                                      <p className="text-lg text-slate-900">
                                        $
                                        {aggregatedSummary?.wages_scheduled?.toLocaleString(
                                          "en-US",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )}
                                      </p>
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div className="px-4 py-3 border border-slate-100 rounded-lg w-[200px]">
                              <p className="text-xs text-slate-900 font-semibold">
                                Actual
                              </p>
                              <div className="mt-2 flex space-x-10">
                                <div>
                                  <p className="text-xxs text-slate-500">
                                    Hours
                                  </p>
                                  <p className="text-lg text-slate-900">
                                    {aggregatedSummary?.hours_worked?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}
                                  </p>
                                </div>
                                {!props.timeEntriesEnabled &&
                                  props.payrollWagesEnabled && (
                                    <div>
                                      <p className="text-xxs text-slate-500">
                                        Earnings
                                      </p>
                                      <p className="text-lg text-slate-900">
                                        $
                                        {aggregatedSummary?.wages_earned?.toLocaleString(
                                          "en-US",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )}
                                      </p>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="mt-8">
                            <EarningsBarChart
                              barChartData={selectedEmployeeSummaryList}
                              timeEntriesEnabled={props.timeEntriesEnabled}
                              payrollWagesEnabled={props.payrollWagesEnabled}
                              timeEntriesHoursRoundedToTenths={props.timeEntriesHoursRoundedToTenths}
                            />
                          </div>
                          <div className="mt-4 w-full px-6">
                            <div className="min-w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
                              <div className="inline-block min-w-full align-middle">
                                <div className="overflow-hidden">
                                  <table className="min-w-full divide-y divide-slate-200">
                                    <thead className="bg-slate-50">
                                      <tr>
                                        {entryTableColumns.map((col) =>
                                          renderSortableHeader(
                                            col,
                                            drillDownSort,
                                            setDrillDownSort
                                          )
                                        )}
                                        {props.timeEntriesEnabled && (
                                          <th
                                            scope="col"
                                            className="relative w-1/12 py-3 pl-3 pr-5 text-right text-xs font-bold uppercase text-slate-500"
                                          >
                                            <div className="flex justify-end">
                                              {(() => {
                                                const selectedPayPeriod = payPeriods.find(pp => pp.uuid === selectedPayPeriodUUID);
                                                const isPublished = selectedPayPeriod?.status === 'published';

                                                if (employeeTimeEntriesUUIDs.length === 0) {
                                                  return null;
                                                }

                                                return (
                                                  <Tooltip
                                                    title={isPublished ? "Cannot modify published pay period" : `Approves all of ${selectedEmployee?.full_name}'s time entries that are pending or flagged. Doesn't affect entries that are approved, denied, or currently working.`}
                                                  >
                                                    <div
                                                      className={`w-28 py-1.5 rounded-full flex items-center justify-center space-x-1 ${
                                                        isPublished
                                                          ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                                                          : 'bg-slate-100 hover:bg-emerald-600 text-emerald-800 hover:text-white cursor-pointer'
                                                      }`}
                                                      onClick={() => {
                                                        if (!isPublished) {
                                                          update_timecard_status(employeeTimeEntriesUUIDs, "approved");
                                                        }
                                                      }}
                                                    >
                                                      <div>
                                                        <DoneAllIcon style={{ fontSize: "16px " }} />
                                                      </div>
                                                      <p>Approve all</p>
                                                    </div>
                                                  </Tooltip>
                                                );
                                              })()}
                                            </div>
                                          </th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-200 bg-white">
                                      {sortEntries(
                                        selectedEmployeeTimeEntries,
                                        drillDownSort
                                      )?.map(
                                        (entry, i) => {
                                          // Use pre-calculated values from backend API
                                          const paidHours = entry.paid_hours ?? 0;
                                          const breakMinutes =
                                            props.timeEntriesEnabled
                                              ? (entry.break_minutes ?? 0)
                                              : hoursToMinutes(
                                                  Number(
                                                    entry.unpaid_break_time
                                                  )
                                                );
                                          const paidBreakMinutes = entry.paid_break_minutes ?? 0;
                                          entry["paid_break_minutes"] = paidBreakMinutes;
                                          entry["clocked_in_at_date_time"] =
                                            new Date(entry.clocked_in_at);
                                          entry["clocked_out_at_date_time"] =
                                            new Date(
                                              entry.clocked_out_at
                                                ? entry.clocked_out_at
                                                : new Date().getTime()
                                            );
                                          entry["status"] = entry.clocked_out_at
                                            ? entry.status
                                            : "currently_working";
                                          entry["sub_status"] =
                                            !entry.clocked_out_at &&
                                            (entry.timecard_breaks?.[
                                              entry.timecard_breaks?.length - 1
                                            ]?.clocked_out_at ||
                                              entry.timecard_breaks?.length ===
                                                0)
                                              ? "Working"
                                              : !entry.clocked_out_at &&
                                                !entry.timecard_breaks?.[
                                                  entry.timecard_breaks
                                                    ?.length - 1
                                                ]?.clocked_out_at
                                              ? (entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]?.is_paid ? "On Paid Break" : "On Break")
                                              : null;
                                          return (
                                            <tr key={i} className="transition-colors hover:bg-slate-50">
                                              <td className="whitespace-nowrap py-5 pl-6 pr-3 text-sm">
                                                <div>
                                                  {
                                                    entry.store_team_member
                                                      .first_name
                                                  }{" "}
                                                  {
                                                    entry.store_team_member
                                                      .last_name
                                                  }
                                                </div>
                                              </td>
                                              {hasMultipleDepartments && (
                                                <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                  <div>
                                                    {getEntryDepartment(entry) ?? (
                                                      <span className="text-slate-400">
                                                        –
                                                      </span>
                                                    )}
                                                  </div>
                                                </td>
                                              )}
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                <div>
                                                  {getEntryJobDisplay(entry) ?? (
                                                    <span className="text-slate-400">
                                                      –
                                                    </span>
                                                  )}
                                                </div>
                                              </td>
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                <div>
                                                  {formatDateReadableWithDayOfWeekNoYear(
                                                    getEntryBusinessDate(entry)
                                                  )}
                                                </div>
                                              </td>
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                {entry.clocked_out_at ? (
                                                  <div className="flex items-center gap-2">
                                                    <span>
                                                      {new Date(
                                                        entry.clocked_in_at
                                                      ).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                      })}{" "}
                                                      -{" "}
                                                      {new Date(
                                                        entry.clocked_out_at
                                                      ).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                      })}
                                                    </span>
                                                    <TimecardHistoryTooltip history={entry.history} timecardId={entry.uuid} rolesList={rolesList} />
                                                  </div>
                                                ) : (
                                                  <div className="flex items-center gap-2">
                                                    <span>
                                                      {new Date(
                                                        entry.clocked_in_at
                                                      ).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                      })}{" "}
                                                      -
                                                    </span>
                                                    <TimecardHistoryTooltip history={entry.history} timecardId={entry.uuid} rolesList={rolesList} />
                                                  </div>
                                                )}
                                              </td>
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                <div>{`${paidHours?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}hrs`}</div>
                                              </td>
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                <div>{`${breakMinutes}min`}</div>
                                                <BreakDetails entry={entry} paid={paidBreakTrackingEnabled ? false : undefined} />
                                              </td>
                                              {paidBreakTrackingEnabled && (
                                                <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                  <div>{`${paidBreakMinutes}min`}</div>
                                                  <BreakDetails entry={entry} paid={true} />
                                                </td>
                                              )}
                                              {/* <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                            <div>${entry.declared_cash_tips ? entry.declared_cash_tips : "0.00"}</div>
                                          </td> */}
                                              {!props.timeEntriesEnabled &&
                                                props.payrollWagesEnabled && (
                                                  <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                    <div>
                                                      $
                                                      {entry.total_pay?.toLocaleString(
                                                        "en-US",
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }
                                                      )}
                                                    </div>
                                                  </td>
                                                )}
                                              <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                                  {entry.status !==
                                                  "currently_working" ? (
                                                    entry.status === "auto_flag" && entry.flag_reason ? (
                                                      <FlagReasonsTooltip flagReason={entry.flag_reason}>
                                                        <div
                                                          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                                                            statusStyles[entry.status]?.classes
                                                          }`}
                                                        >
                                                          <WarningIcon style={{ fontSize: 16 }} />
                                                          {statusStyles[entry.status]?.label || ""}
                                                        </div>
                                                      </FlagReasonsTooltip>
                                                    ) : (
                                                      <div
                                                        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
                                                          statusStyles[
                                                            entry.status
                                                          ]?.classes
                                                        }`}
                                                      >
                                                        {!props.timeEntriesEnabled && entry.status === "auto_approved" && (
                                                          <CheckIcon style={{ fontSize: 16 }} />
                                                        )}
                                                        {statusStyles[
                                                          entry.status
                                                        ]?.label || ""}
                                                      </div>
                                                    )
                                                  ) : (
                                                    props.timeEntriesEnabled ? (
                                                      <div
                                                        className={`w-fit flex items-center space-x-1.5 px-3 py-1 rounded-lg ${
                                                          entry.sub_status ===
                                                          "Working"
                                                            ? "bg-violet-50 border border-violet-300 text-violet-800"
                                                            : entry.sub_status === "On Paid Break"
                                                            ? "bg-blue-50 border border-blue-300 text-blue-800"
                                                            : "bg-orange-50 border border-orange-300 text-orange-800"
                                                        }`}
                                                      >
                                                        <div>
                                                          <BlinkingDot
                                                            sub_status={
                                                              entry.sub_status
                                                            }
                                                          />
                                                        </div>
                                                        <div>
                                                          <p>
                                                            {entry.sub_status}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        className={`w-fit inline-flex items-center gap-2 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
                                                          statusStyles["currently_working"]?.classes
                                                        }`}
                                                      >
                                                        <BlinkingDot sub_status="Working" />
                                                        {statusStyles["currently_working"]?.label || ""}
                                                      </div>
                                                    )
                                                  )}
                                                </td>
                                              {props.timeEntriesEnabled && (
                                                <td className="relative whitespace-nowrap py-5 pl-3 pr-6 text-right text-sm font-medium flex flex-row items-center gap-5 justify-end">
                                                  {renderTimeEntryActions(entry)}
                                                </td>
                                              )}
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                  {selectedEmployeeTimeEntries.length === 0 && (
                                    <div className="flex w-full justify-center border-t border-slate-200 px-6 py-10">
                                      <div className="flex flex-col items-center">
                                        <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center">
                                          <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                                        </div>
                                        <p className="mt-3 text-sm text-slate-400">
                                          {selectedEmployee?.full_name} has no
                                          current time entries for this pay period
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="px-6 mt-8">
                        <div className="flex justify-between">
                          <div>
                            <h1 className="text-xl font-bold text-slate-900">
                              All Time Entries
                            </h1>
                            <h3 className="mt-1 text-slate-500">
                              {`${formatDateReadable(
                                selectedPayPeriodDates[0]
                              )} to ${formatDateReadable(
                                selectedPayPeriodDates[1]
                              )}`}
                            </h3>
                            <TimeEntriesViewSwitcher
                              value={timeEntriesDisplay}
                              onChange={setTimeEntriesDisplay}
                            />
                          </div>
                          <div className="flex items-center space-x-3">
                            {props.timeEntriesEnabled && (() => {
                              const selectedPayPeriod = payPeriods.find(pp => pp.uuid === selectedPayPeriodUUID);
                              const isPublished = selectedPayPeriod?.status === 'published';

                              return (
                                <Tooltip title={isPublished ? "Cannot add time entries to a published pay period" : "Add new time entry"}>
                                  <div
                                    className={`h-10 w-10 rounded-full flex items-center justify-center ${
                                      isPublished
                                        ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                                        : 'bg-violet-700 hover:bg-violet-800 text-white cursor-pointer'
                                    }`}
                                    onClick={() => {
                                      if (!isPublished) {
                                        setModalData(default_data);
                                        setModalEdit(false);
                                        handleOpen();
                                      }
                                    }}
                                  >
                                    <AddIcon />
                                  </div>
                                </Tooltip>
                              );
                            })()}
                            <Tooltip title="Compliance Audit">
                              <div
                                className="h-10 w-10 rounded-full bg-slate-600 hover:bg-slate-700 text-white flex items-center justify-center cursor-pointer"
                                onClick={() => setComplianceAuditOpen(true)}
                              >
                                <GavelIcon style={{ fontSize: "18px" }} />
                              </div>
                            </Tooltip>
                            {!timeEntries.some((entry) =>
                              entry.status === "currently_working" ||
                              (!entry.is_pos_entry && ["pending", "auto_flag"].includes(entry.status))
                            ) ? (
                              <>
                                {props.payrollProvider !== "payroll_provider_paylocity" && props.payrollProvider !== "payroll_provider_qbo" && props.payrollProvider !== "payroll_provider_gusto" &&
                                  <Tooltip title="Download all time entries to a .csv file">
                                    <div
                                      className="px-5 py-2 rounded-full bg-orange-600 hover:bg-orange-700 flex items-center space-x-1 text-white cursor-pointer"
                                      onClick={downloadCSV}
                                    >
                                      <div>
                                        <DownloadIcon />
                                      </div>
                                      <p>Download</p>
                                    </div>
                                  </Tooltip>
                                }
                                {props.payrollProvider === "payroll_provider_paylocity" &&
                                  <Tooltip title="Paylocity Company Export">
                                    <div
                                      className={`px-5 py-2 rounded-full flex items-center space-x-1 text-white ${
                                        isExporting
                                          ? 'bg-emerald-600 cursor-not-allowed'
                                          : 'bg-emerald-600 hover:bg-emerald-700 cursor-pointer'
                                      }`}
                                      onClick={() => !isExporting && generatePaylocityExport(false, selectedPayPeriodDates[0])}
                                    >
                                      <div>
                                        {isExporting ? (
                                          <CircularProgress size="18px" style={{ color: 'white', marginRight: "4px", marginTop: "5px" }} />
                                        ) : (
                                          <ExitToAppIcon />
                                        )}
                                      </div>
                                      <p>{isExporting ? 'Exporting...' : 'Export'}</p>
                                    </div>
                                  </Tooltip>
                                }
                                {props.payrollProvider === "payroll_provider_gusto" &&
                                  renderGustoExportButton()}
                              </>
                            ) : (
                              <>
                                {props.payrollProvider !== "payroll_provider_paylocity" && props.payrollProvider !== "payroll_provider_qbo" && props.payrollProvider !== "payroll_provider_gusto" &&
                                  <Tooltip title="Cannot download until all time entries are approved or denied">
                                    <div className="px-5 py-2 rounded-full bg-slate-200 flex items-center space-x-1 text-slate-400 cursor-not-allowed">
                                      <div>
                                        <DownloadIcon />
                                      </div>
                                      <p>Download</p>
                                    </div>
                                  </Tooltip>
                                }
                                {props.payrollProvider === "payroll_provider_paylocity" &&
                                  <Tooltip title="Paylocity Company Export">
                                    <div
                                      className={`px-5 py-2 rounded-full flex items-center space-x-1 text-white ${
                                        isExporting
                                          ? 'bg-emerald-600 cursor-not-allowed'
                                          : 'bg-emerald-600 hover:bg-emerald-700 cursor-pointer'
                                      }`}
                                      onClick={() => !isExporting && generatePaylocityExport(false, selectedPayPeriodDates[0])}
                                    >
                                      <div>
                                        {isExporting ? (
                                          <CircularProgress size="18px" style={{ color: 'white', marginRight: "4px", marginTop: "5px" }} />
                                        ) : (
                                          <ExitToAppIcon />
                                        )}
                                      </div>
                                      <p>{isExporting ? 'Exporting...' : 'Export'}</p>
                                    </div>
                                  </Tooltip>
                                }
                                {props.payrollProvider === "payroll_provider_gusto" &&
                                  renderGustoExportButton()}
                              </>
                            )}
                            {props.timeEntriesEnabled && (() => {
                              const selectedPayPeriod = payPeriods.find(pp => pp.uuid === selectedPayPeriodUUID);
                              const isPublished = selectedPayPeriod?.status === 'published';
                              const canUnpublish = selectedPayPeriod?.can_unpublish;
                              const hasActiveWorkers = timeEntries.some(entry => entry.status === 'currently_working');
                              const hasPendingEntries = timeEntries.some((entry) =>
                                !entry.is_pos_entry && ["pending", "currently_working", "auto_flag"].includes(entry.status)
                              );
                              const hasPendingChangeRequests = storeChangeRequests.length > 0;
                              const buttonDisabled = isPublishing || !selectedPayPeriod || (!isPublished && (hasPendingEntries || hasActiveWorkers || hasPendingChangeRequests));

                              // If published but user can't unpublish, just show a badge instead of a button
                              if (isPublished && !canUnpublish) {
                                const publishedByName = selectedPayPeriod?.published_by_name;
                                const tooltipText = publishedByName
                                  ? `This pay period was published by ${publishedByName}`
                                  : "This pay period was published by another user";

                                return (
                                  <Tooltip title={tooltipText}>
                                    <div className="px-5 py-2 rounded-full bg-orange-100 text-orange-700 flex items-center space-x-1">
                                      <div>
                                        <CheckIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                      </div>
                                      <p>Published</p>
                                    </div>
                                  </Tooltip>
                                );
                              }

                              let tooltipText = isPublished
                                ? "Click to unpublish this pay period"
                                : hasPendingChangeRequests
                                  ? "Cannot publish until all time entry requests are reviewed"
                                  : hasPendingEntries
                                  ? "Cannot publish until all time entries are approved or denied"
                                  : hasActiveWorkers
                                    ? "Cannot publish while employees are clocked in"
                                    : "Publish this pay period to lock it from editing";

                              return (
                                <Tooltip title={tooltipText}>
                                  <div
                                    className={`px-5 py-2 rounded-full flex items-center space-x-1 ${
                                      buttonDisabled
                                        ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                                        : isPublished
                                          ? 'bg-orange-600 hover:bg-orange-700 text-white cursor-pointer'
                                          : 'bg-emerald-600 hover:bg-emerald-700 text-white cursor-pointer'
                                    }`}
                                    onClick={() => {
                                      if (!buttonDisabled) {
                                        handlePublishPayPeriod(selectedPayPeriodUUID, selectedPayPeriod.status);
                                      }
                                    }}
                                  >
                                    <div>
                                      {isPublished ? (
                                        <LockOpenIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                      ) : (
                                        <LockIcon style={{ fontSize: "18px", marginBottom: "2px" }} />
                                      )}
                                    </div>
                                    <p>{isPublishing ? 'Processing...' : (isPublished ? 'Unpublish' : 'Publish')}</p>
                                  </div>
                                </Tooltip>
                              );
                            })()}
                          </div>
                        </div>
                        {storeChangeRequestsAlert}
                        <div className="flex flex-wrap items-center gap-x-5 gap-y-3 mt-12">
                          <div className="w-48">
                            <p className="text-sm text-slate-500">
                              Filter by name
                            </p>
                            <div className="mt-1">
                              <Select
                                fullWidth
                                multiple
                                displayEmpty
                                value={nameFilter}
                                onChange={handleNameFilterChange}
                                renderValue={(selectedNames) => {
                                  if (!selectedNames || selectedNames.length === 0) {
                                    return "All Employees";
                                  }
                                  if (selectedNames.length === 1) {
                                    return selectedNames[0];
                                  }
                                  return `${selectedNames.length} employees selected`;
                                }}
                                size="small"
                                sx={{
                                  borderRadius: "8px",
                                  paddingY: "1px",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#6d28d9",
                                    },
                                  height: "40px",
                                  backgroundColor: "white",
                                }}
                              >
                                <MenuItem value="all">
                                  <Checkbox
                                    checked={
                                      uniqueNames.length > 0 &&
                                      nameFilter.length === uniqueNames.length
                                    }
                                    indeterminate={
                                      nameFilter.length > 0 &&
                                      nameFilter.length < uniqueNames.length
                                    }
                                    sx={{
                                      color: "#6d28d9",
                                      "&.Mui-checked": {
                                        color: "#6d28d9",
                                      },
                                      "&.MuiCheckbox-indeterminate": {
                                        color: "#6d28d9",
                                      },
                                    }}
                                  />
                                  <ListItemText
                                    primary={
                                      nameFilter.length === uniqueNames.length
                                        ? "Deselect All"
                                        : "Select All"
                                    }
                                    primaryTypographyProps={{ style: { fontWeight: "bold" } }}
                                  />
                                </MenuItem>
                                {uniqueNames.map((name, index) => (
                                  <MenuItem key={index} value={name}>
                                    <Checkbox
                                      checked={nameFilter.includes(name)}
                                      sx={{
                                        color: "#6d28d9",
                                        "&.Mui-checked": {
                                          color: "#6d28d9",
                                        },
                                      }}
                                    />
                                    <ListItemText primary={name} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className="w-48">
                            <p className="text-sm text-slate-500">
                              Filter by date
                            </p>
                            <div className="mt-1">
                              <Select
                                fullWidth
                                multiple
                                displayEmpty
                                value={dateFilter}
                                onChange={handleDateFilterChange}
                                renderValue={(selectedDates) => {
                                  if (!selectedDates || selectedDates.length === 0) {
                                    return "All Dates";
                                  }
                                  if (selectedDates.length === 1) {
                                    return selectedDates[0];
                                  }
                                  return `${selectedDates.length} dates selected`;
                                }}
                                size="small"
                                sx={{
                                  borderRadius: "8px",
                                  paddingY: "1px",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#6d28d9",
                                    },
                                  height: "40px",
                                  backgroundColor: "white",
                                }}
                              >
                                <MenuItem value="all">
                                  <Checkbox
                                    checked={
                                      uniqueDates.length > 0 &&
                                      dateFilter.length === 0
                                    }
                                    indeterminate={
                                      dateFilter.length > 0 &&
                                      dateFilter.length < uniqueDates.length
                                    }
                                    sx={{
                                      color: "#6d28d9",
                                      "&.Mui-checked": {
                                        color: "#6d28d9",
                                      },
                                      "&.MuiCheckbox-indeterminate": {
                                        color: "#6d28d9",
                                      },
                                    }}
                                  />
                                  <ListItemText
                                    primary={
                                      dateFilter.length === 0
                                        ? "All Dates"
                                        : "Select All"
                                    }
                                    primaryTypographyProps={{ style: { fontWeight: "bold" } }}
                                  />
                                </MenuItem>
                                {uniqueDates.map((dateOption, index) => (
                                  <MenuItem key={index} value={dateOption}>
                                    <Checkbox
                                      checked={
                                        dateFilter.length === 0 ||
                                        dateFilter.includes(dateOption)
                                      }
                                      sx={{
                                        color: "#6d28d9",
                                        "&.Mui-checked": {
                                          color: "#6d28d9",
                                        },
                                      }}
                                    />
                                    <ListItemText primary={dateOption} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className="w-48">
                              <p className="text-sm text-slate-500">
                                Filter by status
                              </p>
                              <div className="mt-1">
                                <Select
                                  fullWidth
                                  displayEmpty
                                  value={statusFilter}
                                  onChange={handleStatusFilterChange}
                                  size="small"
                                  sx={{
                                    borderRadius: "8px",
                                    paddingY: "1px",
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#6d28d9",
                                      },
                                    height: "40px",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <MenuItem value="">All Statuses</MenuItem>
                                  {props.timeEntriesEnabled ? (
                                    [
                                      <MenuItem key="approved" value="approved">Approved</MenuItem>,
                                      <MenuItem key="denied" value="denied">Denied</MenuItem>,
                                      <MenuItem key="pending" value="pending">Pending</MenuItem>,
                                      <MenuItem key="auto_flag" value="auto_flag">Flagged</MenuItem>,
                                      <MenuItem key="currently_working" value="currently_working">Currently Working</MenuItem>,
                                    ]
                                  ) : (
                                    [
                                      <MenuItem key="auto_flag" value="auto_flag">Flagged</MenuItem>,
                                      <MenuItem key="auto_approved" value="auto_approved">Passed</MenuItem>,
                                      <MenuItem key="currently_working" value="currently_working">In Progress</MenuItem>,
                                      <MenuItem key="no_status" value="no_status">No Status</MenuItem>,
                                    ]
                                  )}
                                </Select>
                              </div>
                            </div>
                            {hasMultipleDepartments && (
                              <div className="w-48">
                                <p className="text-sm text-slate-500">
                                  Filter by department
                                </p>
                                <div className="mt-1">
                                  <Select
                                    fullWidth
                                    displayEmpty
                                    value={departmentFilter}
                                    onChange={(event) =>
                                      setDepartmentFilter(event.target.value)
                                    }
                                    size="small"
                                    sx={{
                                      borderRadius: "8px",
                                      paddingY: "1px",
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#6d28d9",
                                        },
                                      height: "40px",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <MenuItem value="">All Departments</MenuItem>
                                    {uniqueDepartments.map((department, index) => (
                                      <MenuItem key={index} value={department}>
                                        {department}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </div>
                              </div>
                            )}
                            <div className="w-48">
                              <p className="text-sm text-slate-500">
                                Filter by job
                              </p>
                              <div className="mt-1">
                                <Select
                                  fullWidth
                                  displayEmpty
                                  value={jobFilter}
                                  onChange={(event) =>
                                    setJobFilter(event.target.value)
                                  }
                                  size="small"
                                  sx={{
                                    borderRadius: "8px",
                                    paddingY: "1px",
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#6d28d9",
                                      },
                                    height: "40px",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <MenuItem value="">All Jobs</MenuItem>
                                  {uniqueJobs.map((job, index) => (
                                    <MenuItem key={index} value={job}>
                                      {job}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            </div>
                            <div className="flex-1 min-w-[180px] max-w-xs">
                              <p className="text-sm text-slate-500">Search</p>
                              <div className="mt-1">
                                <TextField
                                  fullWidth
                                  placeholder="Search by name or date..."
                                  value={searchInput}
                                  onChange={(e) => setSearchInput(e.target.value)}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <SearchIcon
                                        sx={{
                                          mr: 1,
                                          color: "text.secondary",
                                          fontSize: 20,
                                        }}
                                      />
                                    ),
                                    endAdornment: searchInput && (
                                      <IconButton
                                        size="small"
                                        onClick={() => setSearchInput("")}
                                      >
                                        <ClearIcon fontSize="small" />
                                      </IconButton>
                                    ),
                                  }}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      height: "40px",
                                      backgroundColor: "white",
                                      borderRadius: "8px",
                                      fontSize: "14px",
                                      "&.Mui-focused fieldset": {
                                        borderColor: "#6d28d9",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>
                        </div>
                      </div>
                      <div className="mt-4 w-full px-6">
                        <div className="min-w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
                          <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden">
                              <table className="min-w-full divide-y divide-slate-200">
                                <thead className="bg-slate-50">
                                  <tr>
                                    {entryTableColumns.map((col) =>
                                      renderSortableHeader(
                                        col,
                                        allEntriesSort,
                                        setAllEntriesSort
                                      )
                                    )}
                                    {props.timeEntriesEnabled && (
                                      <th
                                        scope="col"
                                        className="relative w-1/12 py-3 pl-3 pr-5 text-right text-xs font-bold uppercase text-slate-500"
                                      >
                                        <div className="flex justify-end">
                                          {(() => {
                                            const selectedPayPeriod = payPeriods.find(pp => pp.uuid === selectedPayPeriodUUID);
                                            const isPublished = selectedPayPeriod?.status === 'published';

                                            return (
                                              <Tooltip title={isPublished ? "Cannot modify published pay period" : "Approves all filtered time entries that are pending or flagged. Doesn't affect time entries that are approved, denied, or currently working."}>
                                                <div
                                                  className={`w-28 py-1.5 rounded-full flex items-center justify-center space-x-1 ${
                                                    isPublished
                                                      ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                                                      : 'bg-slate-100 hover:bg-emerald-600 text-emerald-800 hover:text-white cursor-pointer'
                                                  }`}
                                                  onClick={() => {
                                                    if (!isPublished) {
                                                      update_timecard_status(filteredTimeEntriesUUIDs, "approved");
                                                    }
                                                  }}
                                                >
                                                  <div>
                                                    <DoneAllIcon style={{ fontSize: "16px " }} />
                                                  </div>
                                                  <p>Approve all</p>
                                                </div>
                                              </Tooltip>
                                            );
                                          })()}
                                        </div>
                                      </th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-200 bg-white">
                                  {sortEntries(
                                    filteredTimeEntries,
                                    allEntriesSort
                                  )?.map((entry, i) => {
                                    // Use pre-calculated values from backend API
                                    const paidHours = entry.paid_hours ?? 0;
                                    const breakMinutes =
                                      props.timeEntriesEnabled
                                        ? (entry.break_minutes ?? 0)
                                        : hoursToMinutes(
                                            Number(entry.unpaid_break_time)
                                          );
                                    const paidBreakMinutes = entry.paid_break_minutes ?? 0;
                                    entry["paid_break_minutes"] = paidBreakMinutes;
                                    entry["clocked_in_at_date_time"] = new Date(
                                      entry.clocked_in_at
                                    );
                                    entry["clocked_out_at_date_time"] =
                                      new Date(
                                        entry.clocked_out_at
                                          ? entry.clocked_out_at
                                          : new Date().getTime()
                                      );
                                    entry["status"] = entry.clocked_out_at
                                      ? entry.status
                                      : "currently_working";
                                    entry["sub_status"] =
                                      !entry.clocked_out_at &&
                                      (entry.timecard_breaks?.[
                                        entry.timecard_breaks?.length - 1
                                      ]?.clocked_out_at ||
                                        entry.timecard_breaks?.length === 0)
                                        ? "Working"
                                        : !entry.clocked_out_at &&
                                          !entry.timecard_breaks?.[
                                            entry.timecard_breaks?.length - 1
                                          ]?.clocked_out_at
                                        ? (entry.timecard_breaks?.[entry.timecard_breaks?.length - 1]?.is_paid ? "On Paid Break" : "On Break")
                                        : null;
                                    return (
                                      <tr key={i} className="transition-colors hover:bg-slate-50">
                                        <td className="whitespace-nowrap py-5 pl-6 pr-3 text-sm">
                                          <div>
                                            {
                                              entry?.store_team_member
                                                ?.first_name
                                            }{" "}
                                            {
                                              entry?.store_team_member
                                                ?.last_name
                                            }
                                          </div>
                                        </td>
                                        {hasMultipleDepartments && (
                                          <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                            <div>
                                              {getEntryDepartment(entry) ?? (
                                                <span className="text-slate-400">
                                                  –
                                                </span>
                                              )}
                                            </div>
                                          </td>
                                        )}
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                          <div>
                                            {getEntryJobDisplay(entry) ?? (
                                              <span className="text-slate-400">
                                                –
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                          <div>
                                            {formatDateReadableWithDayOfWeekNoYear(
                                              getEntryBusinessDate(entry)
                                            )}
                                          </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                          {entry.clocked_out_at ? (
                                            <div className="flex items-center gap-2">
                                              <span>
                                                {new Date(
                                                  entry.clocked_in_at
                                                ).toLocaleTimeString([], {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                })}{" "}
                                                -{" "}
                                                {new Date(
                                                  entry.clocked_out_at
                                                ).toLocaleTimeString([], {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                })}
                                              </span>
                                              <TimecardHistoryTooltip history={entry.history} timecardId={entry.uuid} rolesList={rolesList} />
                                            </div>
                                          ) : (
                                            <div className="flex items-center gap-2">
                                              <span>
                                                {new Date(
                                                  entry.clocked_in_at
                                                ).toLocaleTimeString([], {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                })}{" "}
                                                -
                                              </span>
                                              <TimecardHistoryTooltip history={entry.history} timecardId={entry.uuid} rolesList={rolesList} />
                                            </div>
                                          )}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                          <div>{`${paidHours?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}hrs`}</div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                          <div>{`${breakMinutes}min`}</div>
                                          <BreakDetails entry={entry} paid={paidBreakTrackingEnabled ? false : undefined} />
                                        </td>
                                        {paidBreakTrackingEnabled && (
                                          <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                            <div>{`${paidBreakMinutes}min`}</div>
                                            <BreakDetails entry={entry} paid={true} />
                                          </td>
                                        )}
                                        {!props.timeEntriesEnabled &&
                                          props.payrollWagesEnabled && (
                                            <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                              <div>
                                                $
                                                {entry.total_pay?.toLocaleString(
                                                  "en-US",
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }
                                                )}
                                              </div>
                                            </td>
                                          )}
                                        {/* <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                        <div>${entry.declared_cash_tips ? entry.declared_cash_tips : "0.00"}</div>
                                      </td> */}
                                        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                            {entry.status !==
                                            "currently_working" ? (
                                              entry.status === "auto_flag" && entry.flag_reason ? (
                                                <FlagReasonsTooltip flagReason={entry.flag_reason}>
                                                  <div
                                                    className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                                                      statusStyles[entry.status]?.classes
                                                    }`}
                                                  >
                                                    <WarningIcon style={{ fontSize: 16 }} />
                                                    {statusStyles[entry.status]?.label || ""}
                                                  </div>
                                                </FlagReasonsTooltip>
                                              ) : (
                                                <div
                                                  className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
                                                    statusStyles[entry.status]
                                                      ?.classes
                                                  }`}
                                                >
                                                  {!props.timeEntriesEnabled && entry.status === "auto_approved" && (
                                                    <CheckIcon style={{ fontSize: 16 }} />
                                                  )}
                                                  {statusStyles[entry.status]
                                                    ?.label || ""}
                                                </div>
                                              )
                                            ) : (
                                              props.timeEntriesEnabled ? (
                                                <div
                                                  className={`w-fit flex items-center space-x-1.5 px-3 py-1 rounded-lg ${
                                                    entry.sub_status === "Working"
                                                      ? "bg-violet-50 border border-violet-300 text-violet-800"
                                                      : entry.sub_status === "On Paid Break"
                                                      ? "bg-blue-50 border border-blue-300 text-blue-800"
                                                      : "bg-orange-50 border border-orange-300 text-orange-800"
                                                  }`}
                                                >
                                                  <div>
                                                    <BlinkingDot
                                                      sub_status={
                                                        entry.sub_status
                                                      }
                                                    />
                                                  </div>
                                                  <div>
                                                    <p>{entry.sub_status}</p>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className={`w-fit inline-flex items-center gap-2 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
                                                    statusStyles["currently_working"]?.classes
                                                  }`}
                                                >
                                                  <BlinkingDot sub_status="Working" />
                                                  {statusStyles["currently_working"]?.label || ""}
                                                </div>
                                              )
                                            )}
                                          </td>
                                        {props.timeEntriesEnabled && (
                                          <td className="relative whitespace-nowrap py-5 pl-3 pr-6 text-right text-sm font-medium flex flex-row items-center gap-5 justify-end">
                                            {renderTimeEntryActions(entry)}
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                              {filteredTimeEntries.length === 0 && (
                                <div className="flex w-full justify-center border-t border-slate-200 px-6 py-10">
                                  <div className="flex flex-col items-center">
                                    <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center">
                                      <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                                    </div>
                                    <p className="mt-3 text-sm text-slate-400">
                                      No time entries match this filter criteria
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div>
                  <TimeEntriesHeader
                    title="Pay Periods"
                    storeOptions={props.storeOptions}
                    homeStore={props.homeStore}
                    storeNames={props.storeNames}
                    change_home_store={props.change_home_store}
                    setCurrentTab={props.setCurrentTab}
                    showSettings={showSettings}
                    setShowSettings={setShowSettings}
                    timeEntriesEnabled={props.timeEntriesEnabled}
                    payrollEnabled={props.payrollEnabled}
                  />
                </div>
                <div className="mx-auto mt-12 w-full max-w-6xl px-6 pb-8">
                  <div className="mb-4 flex justify-end">
                    <button type="button" className="flex h-[42px] items-center gap-2 rounded-lg border border-violet-700 bg-white px-4 text-sm font-medium text-violet-700 hover:bg-violet-50" onClick={() => { handleClose(); setShowCustomRange(true); }}>
                      <DateRangeIcon style={{ fontSize: 18 }} />
                      <span>Custom date range</span>
                    </button>
                  </div>
                  <div className="min-w-full overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
                    <div className="inline-block min-w-full align-middle">
                      <div className="overflow-hidden">
                        <table className="min-w-full divide-y divide-slate-200">
                          <thead className="bg-slate-50">
                            <tr>
                              <th
                                scope="col"
                                className="flex-1 py-3 pl-5 pr-3 text-left text-xs font-bold uppercase text-slate-500"
                              >
                                Pay Period
                              </th>
                              <th
                                scope="col"
                                className="flex-1 px-3 py-3 text-left text-xs font-bold uppercase text-slate-500"
                              >
                                Hours Paid
                              </th>
                              {!props.timeEntriesEnabled &&
                                props.payrollWagesEnabled && (
                                  <th
                                    scope="col"
                                    className="flex-1 px-3 py-3 text-left text-xs font-bold uppercase text-slate-500"
                                  >
                                    Total Cost
                                  </th>
                                )}
                              {/* <th
                              scope="col"
                              className="flex-1 px-3 py-3.5 text-left text-xs font-semibold text-slate-500"
                            >
                              Employee Approvals
                            </th> */}
                              {/* <th
                              scope="col"
                              className="flex-1 px-3 py-3.5 text-left text-xs font-semibold text-slate-500"
                            >
                              Status
                            </th> */}
                              <th
                                scope="col"
                                className="relative w-1/12 py-3 pl-3 pr-5"
                              >
                                {/* <span className="sr-only">Edit</span> */}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-200 bg-white">
                            {payPeriods.map((period, i) => (
                              <tr
                                key={i}
                                className="group cursor-pointer transition-colors hover:bg-slate-50"
                                onClick={() =>
                                  handleSelectPayPeriod(
                                    period.beginning_date,
                                    period.end_date,
                                    period.uuid
                                  )
                                }
                              >
                                <td className="whitespace-nowrap py-4 pl-5 pr-3 text-sm">
                                  <div className="font-medium text-slate-900">
                                    {formatDateReadable(period.beginning_date)}{" "}
                                    - {formatDateReadable(period.end_date)}
                                  </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-700">
                                  <div>
                                    {period?.timecard_summary_data?.payable_hours?.toFixed(props.timeEntriesHoursRoundedToTenths ? 1 : 2)}
                                  </div>
                                </td>
                                {!props.timeEntriesEnabled &&
                                  props.payrollWagesEnabled && (
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-700">
                                      <div>
                                        $
                                        {period?.timecard_summary_data
                                          ?.total_pay
                                          ? period?.timecard_summary_data?.total_pay?.toLocaleString(
                                              "en-US",
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )
                                          : "0.00"}
                                      </div>
                                    </td>
                                  )}
                                {/* <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                                <div>
                                  10 / 24
                                </div>
                              </td> */}
                                <td className="relative flex flex-row items-center justify-end gap-5 whitespace-nowrap py-4 pl-3 pr-5 text-right text-sm font-medium">
                                  {period?.status === 'published' && (
                                    <div className="px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-medium">
                                      Published
                                    </div>
                                  )}
                                  <div className="text-slate-400 transition-colors group-hover:text-slate-600">
                                    <ChevronRightIcon />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {payPeriods.length === 0 && (
                          <div className="flex w-full justify-center border-t border-slate-200 px-6 py-10">
                            <div className="flex flex-col items-center">
                              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100">
                                <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                              </div>
                              <p className="mt-3 text-sm text-slate-400">
                                No pay periods available
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <TimeEntriesSettings
              title={
                showTimeEntries ? "Back to Time Entries" : "Back to Pay Periods"
              }
              storeOptions={props.storeOptions}
              homeStore={props.homeStore}
              storeNames={props.storeNames}
              change_home_store={props.change_home_store}
              setCurrentTab={props.setCurrentTab}
              handleGoBack={handleGoBack}
              showTimeEntries={showTimeEntries}
              setShowTimeEntries={setShowTimeEntries}
              showSettings={showSettings}
              setShowSettings={setShowSettings}
              timeEntriesEnabled={props.timeEntriesEnabled}
            />
          </div>
        )
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadSpinner />
        </div>
      )}
      <ThemeProvider theme={timeClockTheme}>
        <Drawer open={open} anchor="right" onClose={handleClose} PaperProps={{ sx: { width: "min(450px, 100vw)" } }}>
          <div className="w-[450px] max-w-[100vw] h-full">
            <div className="max-h-screen overflow-auto">
              <DrawerHeader
                title={modalEdit ? "Edit Time Entry" : "Add Time Entry"}
                onClose={handleClose}
              />
              <div className="w-full px-6">
                {(() => {
                  const validationErrors = submitted ? getValidationErrors() : {};
                  return (
                <>
                <div className="mt-5">
                  <p className="text-sm text-slate-500">Name</p>
                  <div className="mt-1">
                    <Select
                      fullWidth
                      value={modalData?.store_team_member?.id}
                      onChange={handleNameChange}
                      size="small"
                      error={!!validationErrors.employee}
                      sx={{
                        borderRadius: "8px",
                        paddingY: "1px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                        height: "45px",
                        backgroundColor: "white",
                      }}
                    >
                      {(selfTimecardEditBlocked && !modalEdit
                        ? filteredEmployeeList.filter(
                            (member) => member.id !== myStoreTeamMemberId
                          )
                        : filteredEmployeeList
                      ).map((member, index) => (
                        <MenuItem key={index} value={member.id}>
                          {`${member.first_name} ${member.last_name}`}
                        </MenuItem>
                      ))}
                    </Select>
                    {validationErrors.employee && (
                      <p className="text-red-500 text-xs mt-1">{validationErrors.employee}</p>
                    )}
                  </div>
                </div>
                {props.timeEntriesRoleSelectionEnabled && (
                 <div className="mt-5">
                   <p className="text-sm text-slate-500">Role</p>
                   <div className="mt-1">
                     <Select
                       fullWidth
                       value={modalData?.role?.id || ""}
                       onChange={handleRoleChange}
                       size="small"
                       sx={{
                         borderRadius: "8px",
                         paddingY: "1px",
                         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                           borderColor: "#6d28d9",
                         },
                         height: "45px",
                         backgroundColor: "white",
                       }}
                     >
                       <MenuItem value="">
                         <em>None</em>
                       </MenuItem>
                       {rolesList.map((role, index) => (
                         <MenuItem key={index} value={role.id}>
                           {role.role_name}
                         </MenuItem>
                       ))}
                     </Select>
                   </div>
                 </div>
               )}
                <div>
                  <div className="mt-5">
                    <p className="text-sm text-slate-500">Shift Clock In</p>
                    <div className="mt-1">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                          // label="Clocked In"
                          views={["month", "day", "hours", "minutes"]}
                          value={modalData.clocked_in_at_date_time}
                          onChange={(newValue) =>
                            handleDateTimeChange(
                              "clocked_in_at_date_time",
                              newValue
                            )
                          }
                          slotProps={{
                            textField: {
                              inputProps: { "aria-label": "Shift clock in" },
                              error: !!validationErrors.clockIn,
                              helperText: validationErrors.clockIn,
                              sx: {
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "8px !important",
                                  height: "45px",
                                  width: "100%",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#6d28d9",
                                    },
                                  backgroundColor: "white",
                                },
                              },
                            },
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  {(!modalEdit || modalData.clocked_out_at) && (
                    <div className="mt-5">
                      <p className="text-sm text-slate-500">Shift Clock Out</p>
                      <div className="mt-1">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DateTimePicker
                            // label="Clocked Out
                            views={["month", "day", "hours", "minutes"]}
                            value={modalData.clocked_out_at_date_time}
                            onChange={(newValue) =>
                              handleDateTimeChange(
                                "clocked_out_at_date_time",
                                newValue
                              )
                            }
                            slotProps={{
                              textField: {
                                inputProps: { "aria-label": "Shift clock out" },
                                error: !!validationErrors.clockOut,
                                helperText: validationErrors.clockOut,
                                sx: {
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px !important",
                                    height: "45px",
                                    width: "100%",
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#6d28d9",
                                      },
                                    backgroundColor: "white",
                                  },
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  )}
                </div>
                {(!modalEdit || modalData.clocked_out_at) && (
                  <BreakEditor
                    breaks={modalData.timecard_breaks}
                    onChange={handleBreaksChange}
                    errors={validationErrors.breaks}
                    shiftStart={modalData.clocked_in_at_date_time?.getTime()}
                    shiftEnd={modalData.clocked_out_at_date_time?.getTime()}
                    paidBreakTrackingEnabled={paidBreakTrackingEnabled}
                  />
                )}
                {validationErrors.breakBounds && (
                  <p role="alert" className="mt-2 text-sm text-red-700">{validationErrors.breakBounds}</p>
                )}
                <div className="mt-5">
                  <p className="text-sm text-slate-500">
                    Note
                  </p>
                  <div className="mt-1">
                    <TextField
                      placeholder={modalEdit ? "Why are you editing this time entry?" : "Why are you adding this time entry?"}
                      fullWidth
                      multiline
                      rows={3}
                      variant="outlined"
                      value={modalData.manager_note || ""}
                      onChange={(event) => {
                        setModalData({
                          ...modalData,
                          manager_note: event.target.value
                        });
                      }}
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "10px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
                {/* <div className="mt-5">
                  <p className="text-sm text-slate-500">Cash Tips</p>
                  <div className="mt-1">
                    <TextField
                      placeholder="50.75"
                      fullWidth
                      variant="outlined"
                      size="small"
                      // name="target_column"
                      value={modalData.declared_cash_tips}
                      onChange={(event) => {
                        const value = event.target.value;
                        // Check if the value is a valid number
                        if (!isNaN(value)) {
                          handleTipChange(event);
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "5px",
                          paddingLeft: "20px",
                          height: "45px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div> */}
                </>
                  );
                })()}
              </div>
              <div className="h-[200px]"></div>
            </div>
            <div>
              <DrawerFooterContainerLarge>
                <div className="w-full">
                  <LoadingButton
                    variant="contained"
                    // loading={savingLoading}
                    loadingPosition="end"
                    endIcon={<SaveIcon />}
                    disabled={submitted && Object.keys(getValidationErrors()).length > 0}
                    onClick={() => handleSubmit()}
                    sx={{
                      width: "100%",
                      textTransform: "none",
                      borderRadius: "12px",
                      paddingY: "14px",
                      backgroundColor: "#6d28d9",
                      "&:hover": {
                        backgroundColor: "#5b21b6",
                      },
                      fontSize: "16px",
                    }}
                  >
                    {modalEdit ? "Save Changes" : "Save Time Entry"}
                  </LoadingButton>
                </div>
                <div className="w-full mt-3">
                  <ButtonOutlined text="Cancel" onClick={() => handleClose()} />
                </div>
              </DrawerFooterContainerLarge>
            </div>
          </div>
        </Drawer>
      </ThemeProvider>
      <TipCalculatorModal
        open={tipCalculatorOpen}
        onClose={() => setTipCalculatorOpen(false)}
        payPeriodEmployees={payPeriodEmployees}
        selectedPayPeriodDates={selectedPayPeriodDates}
        platformTipTotalCents={platformTipTotalCents}
        creditCardTipAmountCents={creditCardTipAmountCents}
        cashTipAmountCents={cashTipAmountCents}
        tipList={tipList}
        selectedPayPeriodUUID={selectedPayPeriodUUID}
        homeStore={props.homeStore}
        onSubmitSuccess={() => fetchPayPeriodEmployees(false, selectedPayPeriodUUID)}
      />
      <LaborComplianceAuditModal
        open={complianceAuditOpen}
        onClose={() => setComplianceAuditOpen(false)}
        homeStore={props.homeStore}
        selectedPayPeriodDates={selectedPayPeriodDates}
      />
    </>
  );
}

export default TimeEntriesDisplay;
